import { useState, useEffect, useRef, forceUpdate } from 'react';
import { Link, Redirect, useLocation } from 'react-router-dom';
import Select from 'react-select';
import Hosts from '../../../Hosts';
import { object_type, api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';
import Loader from '../../Loader/Loader';
import Swal from 'sweetalert2';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { Modal, Button, Form } from 'react-bootstrap';
import SortableTree from 'react-sortable-tree';

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,
	pattern_vat,
	pattern_email,
	passwordHash,
	translate,
	handle_compressed_image_upload,
	set_language
} from '../../../Utils';

import { language } from './Language';
import { color } from '../../WEBContent/Color';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(data_interface);
	const permissions = useRef(null);
	const { pathname } = useLocation();

	const entity_category = useRef(null);
	const entity_type = useRef(null);
	const entity_type_filter = useRef(null);
	const entity_nature = useRef(null);
	const entity_nature_filter = useRef(null);
	const entity_quality = useRef(null);
	const entity_quality_filter = useRef(null);
	const entity_legal_form = useRef(null);
	const entity_legal_form_filter = useRef(null);
	const entity_relation = useRef(null);
	const entity_relation_raw = useRef(null);
	const entity_relation_filter = useRef(null);

	const app_profiles = useRef(null);
	const app_profiles_filter = useRef(null);
	const entity_profiles = useRef(null);
	const entity_profiles_filter = useRef(null);
	const entity_function = useRef(null);
	const entity_function_filter = useRef(null);

	const pay_fee_available = useRef();

	const [lang, set_lang] = useState('pt');
	const [lang_id, set_lang_id] = useState('1');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [refresh, setRefresh] = useState(0);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')

	const [is_edit, set_is_edit] = useState(false)

	const [, set_show_district_city_village] = useState('');
	const [, set_disabled] = useState(false)

	const [countries, set_countries] = useState([])
	const [districts, set_districts] = useState([])
	const [cities, set_cities] = useState([])
	const [villages, set_villages] = useState([])

	/////////////////////////////////////////////////////////////////////////
	const [, setSelectedUserTypeId] = useState('');
	const [userTypes, setUserTypes] = useState([]);
	const [userTypesEntities, setUserTypesEntities] = useState([]);
	const [modalDetalhes, setModalDetalhes] = useState(false);

	//Responsaveis///////////////////////////////////////////////////////////
	const [modalResponsavel, setModalResponsavel] = useState(false);
	const [responsavelInputNome, setResponsavelInputNome] = useState('');
	const [responsavelInputEmail, setResponsavelInputEmail] = useState('');
	const [responsavelInputTel, setResponsavelInputTel] = useState('');

	const [clubes, setClubes] = useState([]);
	const [, setAllResponsaveis] = useState([]);
	const [, setTeamLeader] = useState([]);

	//Departamento
	const [modalDepartamento, setModalDepartamento] = useState(false);
	const [departamentos, setDepartamentos] = useState([]);
	const [selectedDepartamentoId, setSelectedDepartamentoId] = useState('');
	const [, setDepartamentoSelecionado] = useState([]);
	const [departamentoInput, setDepartamentoInput] = useState('');
	const [selectedDepartamento, setSelectedDepartamento] = useState(null);
	const [selectedSoftware, setSelectedSoftware] = useState({});

	//Entidade Interna
	const [, setColaborador] = useState('');
	const [selectedColaborador, setSelectedColaborador] = useState('');
	const [tag, setTag] = useState('');

	//Entidade Externa
	const [, setTipoCliente] = useState('');
	const [selectedTipoCliente, setSelectedTipoCliente] = useState('');

	//relacao	
	const [, setSelectedTipoRelacao] = useState('');

	//foto	
	const [files_image, set_files_image] = useState([]);
	const [image_base64, set_image_base64] = useState([]);
	const [photo_base64, set_photo_base64] = useState('');
	const [img_loader, set_img_loader] = useState([])

	//pdf
	const [files_doc, set_files_doc] = useState([]);
	const [files_doc_name, set_files_doc_name] = useState([]);
	const [treeDataCV, setTreeDataCV] = useState([])

	const [showOverView, setShowOverview] = useState(true);
	const [showNat, setShowNat] = useState(false);
	const [showFunctions, setShowFunctions] = useState(false);
	const [showSportData, setShowSportData] = useState(false);
	const [showGuardians, setShowGuardians] = useState(false);
	const [showSettings, setShowSettings] = useState(false);
	const [showSelecoes, setShowSelecoes] = useState(false);

	const calculate_age = (birthday) => {
		if (!birthday) return null;
		const birthDate = new Date(birthday);
		if (isNaN(birthDate.getTime())) return null;
		const today = new Date();
		let age = today.getFullYear() - birthDate.getFullYear();
		const m = today.getMonth() - birthDate.getMonth();
		if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
			age--;
		}
		return age;
	};

	const entity_age = calculate_age(dados.current.info.birthday);
	const is_minor = entity_age !== null && entity_age < 18;
	const is_selecionado = Array.isArray(dados?.current?.info?.categoria) ? dados.current.info.categoria.includes('selecoes') : false;

	const ESCALOES_GERAL = [
		{ id: 'U10', label: 'U10', min: 2016, max: Infinity },
		{ id: 'U12', label: 'U12', min: 2014, max: 2015 },
		{ id: 'U14', label: 'U14', min: 2012, max: 2013 },
		{ id: 'U16', label: 'U16', min: 2010, max: 2011 },
		{ id: 'U18', label: 'U18', min: 2008, max: 2009 },
		{ id: 'U21', label: 'U21', min: 2005, max: 2007 },
		{ id: 'SENIOR', label: 'Sénior', min: 1991, max: 2004 },
		{ id: 'M35', label: 'M35', min: 1971, max: 1990 },
		{ id: 'M55', label: 'M55', min: -Infinity, max: 1970 },
	];

	const ESCALOES_SNOWBOARD = [
		{ id: 'U9', label: 'U9 (kids)', min: 2017, max: Infinity },
		{ id: 'U11', label: 'U11 (SuperGrom)', min: 2015, max: 2016 },
		{ id: 'U13', label: 'U13 (SuperGrom)', min: 2013, max: 2014 },
		{ id: 'U15', label: 'U15 (Grom)', min: 2011, max: 2012 },
		{ id: 'U18_ROOKIE', label: 'U18 (Rookie)', min: 2008, max: 2010 },
		{ id: 'ABSOLUTO', label: 'Absoluto', min: 1985, max: 2007 },
		{ id: 'M40', label: 'M40 (Master)', min: -Infinity, max: 1984 },
	];

	const ESCALOES_PATINAGEM = [
		{ id: 'PRE_INICIADO', label: 'Pré-Iniciado' },
		{ id: 'NOVATOS', label: 'Novatos' },
		{ id: 'JUNIORES', label: 'Juniores' },
		{ id: 'SENIORES', label: 'Seniores' },
		{ id: 'ADULTOS', label: 'Adultos' },
	];

	const OPCOES_ESCALAO = {
		geral: ESCALOES_GERAL,
		snowboard: ESCALOES_SNOWBOARD,
		patinagem: ESCALOES_PATINAGEM,
	};

	const anoNascimento = (birthday) => {
		if (!birthday) return null;
		const ano = parseInt(String(birthday).slice(0, 4), 10);
		return Number.isNaN(ano) ? null : ano;
	};

	const escalaoPorAno = (ano, tabela) => {
		if (ano === null) return '';
		const item = tabela.find(e => ano >= e.min && ano <= e.max);
		return item ? item.id : '';
	};

	// Idade de referência = idade que o atleta tem a 1 de julho do ano em que a época começa
	const idadeReferencia = (birthday, anoEpoca) => {
		if (!birthday) return null;
		const nascimento = new Date(birthday);
		const referencia = new Date(anoEpoca, 6, 1); // 1 de julho
		let idade = referencia.getFullYear() - nascimento.getFullYear();
		const diffMes = referencia.getMonth() - nascimento.getMonth();
		if (diffMes < 0 || (diffMes === 0 && referencia.getDate() < nascimento.getDate())) idade--;
		return idade;
	};

	// Faixas sobrepostas (Novatos/Juniores/Seniores) -> prioridade: mais "novo" primeiro
	const escalaoPorIdade = (idade) => {
		if (idade === null) return '';
		if (idade >= 28) return 'ADULTOS';
		if (idade > 13 && idade <= 18) return 'JUNIORES';
		if (idade >= 8 && idade <= 13) return 'NOVATOS';
		if (idade >= 17) return 'SENIORES';
		if (idade >= 6) return 'PRE_INICIADO';
		return '';
	};

	const detectarGrupoModalidade = (modalidades) => {
		if (!Array.isArray(modalidades) || modalidades.length === 0) 
			return 'geral';

		console.log('modalidades', modalidades)

		const valores = modalidades.map(m => (m.label ?? m.value ?? m ?? '').toString().toLowerCase());

		console.log('valores', valores)

		if (valores.some(v => v.includes('patinagem'))) 
			return 'patinagem';
		if (valores.some(v => v.includes('snowboard'))) 
			return 'snowboard';
		
		return 'geral';
	};

	// anoEpoca = ano civil em que a época desportiva começa (ex: 2025 para a época 2025/2026)
	const calcularEscalao = (birthday, modalidades, anoEpoca) => {
		const grupo = detectarGrupoModalidade(modalidades);
		if (grupo === 'patinagem') {
			return escalaoPorIdade(idadeReferencia(birthday, anoEpoca));
		}
		const tabela = grupo === 'snowboard' ? ESCALOES_SNOWBOARD : ESCALOES_GERAL;
		return escalaoPorAno(anoNascimento(birthday), tabela);
	};

	const getAnoEpocaAtual = () => {
		const hoje = new Date();
		const anoAtual = hoje.getFullYear();
		const mesAtual = hoje.getMonth(); // 0 = janeiro, 6 = julho

		// Época muda em julho (mês índice 6)
		return mesAtual >= 6 ? anoAtual : anoAtual - 1;
	};

	const escalaoAutoRef = useRef(''); // <-- em falta

	useEffect(() => {


		console.log('is_selecionado', is_selecionado)

		const anoEpoca = getAnoEpocaAtual();

		const sugestao = calcularEscalao(
			dados.current.info.birthday,
			dados.current.info.modalidades,
			anoEpoca
		);

		// if (!dados.current.info.escalao || dados.current.info.escalao === escalaoAutoRef.current) {
			escalaoAutoRef.current = sugestao;
			set_dados(dados.current.info.escalao = sugestao);
		// }

	}, [dados.current.info.birthday, JSON.stringify(dados.current.info.modalidades)]);

	const grupoModalidadeAtual = detectarGrupoModalidade(dados.current.info.modalidades);
	const opcoesEscalaoAtual = OPCOES_ESCALAO[grupoModalidadeAtual];

	const ANO_EPOCA = (() => {
		const hoje = new Date();
		return hoje.getMonth() >= 6 ? hoje.getFullYear() : hoje.getFullYear() - 1;
	})();

	const TABS = [
		{ key: 'overview', perm: 'identificacao', label: 'identification', show: showOverView, set: () => selectTab('overview') },
		{ key: 'nat', perm: 'naturalidade', label: 'naturalidade', show: showNat, set: () => selectTab('nat') },
		{ key: 'funcoes', perm: 'funcoes', label: 'functions', show: showFunctions, set: () => selectTab('funcoes') },
		{ key: 'desportivo', perm: 'desportivo', label: 'dados_desportivos', show: showSportData, set: () => selectTab('desportivo'), alwaysShow: true },
		{ key: 'selecoes', perm: 'selecoes', label: 'selecoes', show: showSelecoes, set: () => selectTab('selecoes'), selecionado: true },
		{ key: 'encarregados', perm: 'encarregados', label: 'pais_encarregados', show: showGuardians, set: () => selectTab('encarregados'), minorOnly: true },
		{ key: 'settings', perm: 'configuracoes', label: 'settings', show: showSettings, set: () => selectTab('settings') },
	];

	const selectTab = (tabKey) => {
		setShowOverview(tabKey === 'overview');
		setShowNat(tabKey === 'nat');
		setShowFunctions(tabKey === 'funcoes');
		setShowSportData(tabKey === 'desportivo');
		setShowSelecoes(tabKey === 'selecoes');
		setShowGuardians(tabKey === 'encarregados');
		setShowSettings(tabKey === 'settings');
	};

	const TabButtons = () => (
		<div className="d-flex flex-wrap justify-content-end gap-1 mb-3">
			{TABS.map((tab) => {
				const visible = tab.minorOnly ? 
					is_minor
				: 
				tab.selecionado ?
					is_selecionado
				:
					(tab.alwaysShow || (permissions.current != null && !!permissions.current[tab.perm]));
				
				if (!visible) 
					return null;
				
				return (
					<button
						key={tab.key}
						type="button"
						className={`btn rounded-pill btn-sm px-3 py-1 ${tab.show ? 'btn-primary shadow-sm' : 'btn-outline-secondary'}`}
						style={{ fontSize: '13px', fontWeight: 500, transition: 'all .15s ease' }}
						onClick={tab.set}
					>
						{language[lang][tab.label]}
					</button>
				);
			})}
		</div>
	);

	const tableStyle = {
		width: '100%',
		borderCollapse: 'collapse',
		fontSize: '14px',
		color: color.cor1.hexa,
		textAlign: 'left',
		boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
		borderRadius: '8px',
		overflow: 'hidden',
		backgroundColor: color.cor3.hexa,
	};

	const headerCellStyle = {
		padding: '12px 15px',
		textAlign: 'center',
		color: color.cor3.hexa,
		fontWeight: '600',
		borderBottom: '2px solid #ddd',
		backgroundColor: color.cor2.rgb,
		textTransform: 'uppercase',
	};

	const departamentoHeaderCellStyle = {
		...headerCellStyle,
		textAlign: 'left',
	};

	const cellStyle = {
		borderBottom: `1px solid rgb(${color.cor3.rgb})`,
		textAlign: 'center',
		verticalAlign: 'middle',
		padding: '12px 15px',
		color: color.corCinza.hexa,
		lineHeight: '1.6',
		backgroundColor: '#fafafa',
	};

	const rowStyle = {
		fontSize: '14px',
		backgroundColor: color.cor3.hexa,
		transition: 'background-color 0.3s ease',
	};

	const actionCellStyle = {
		padding: '10px',
		border: '1px solid #ddd',
		textAlign: 'center',
		verticalAlign: 'middle',
		width: '50px',
		backgroundColor: color.cor1.hexa,
		transition: 'background-color 0.3s',
	};

	const departmentCellStyle = {
		backgroundColor: color.cor1.hexa,
		...cellStyle,
		textAlign: 'left',
		fontWeight: '500',
	};

	const lastRowStyle = {
		borderBottom: '0.5px solid grey',
	};

	const onChangeHandlerFilesImage = async (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);
		let files_img_aux = image_base64

		let k = 0
		// filesArray.forEach(async (v, k) => {
		for await (let v of filesArray) {
			if ((v.type.includes('image/')) && (v.size < 10485760)) {

				await handle_compressed_image_upload(v, (valor) => storedFiles.push(valor))

				await convertBase64(v)
					.then((base64) => {

						if (files_img_aux[order] === undefined)
							files_img_aux[order] = []
						if (files_img_aux[order][langid] === undefined)
							files_img_aux[order][langid] = []

						files_img_aux[order][langid].push({ id: '1', langid: langid, name: v.name.split('.')[0] + '.webp', link: base64 })
						set_image_base64(files_img_aux)
						set_photo_base64(base64)
						setRefresh(refresh + Math.random())
					})


				if (filesArray.length === (k + 1)) {
					setRefresh(refresh + parseInt(v.size) + k)
				}

			}
			else {
				Swal.fire(language[lang].upload_image_error + v.name, '', 'info')
			}

			k++
		}

		let files_aux = files_image
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_image(files_aux)

	}

	const convertBase64 = async (file) => {
		return new Promise((resolve, reject) => {
			const fileReader = new FileReader();
			fileReader.readAsDataURL(file);

			fileReader.onload = () => {
				resolve(fileReader.result);
			};

			fileReader.onerror = (error) => {
				reject(error);
			};
		});
	};

	const handleFileRemove = () => {

		set_dados(dados.current.info.foto = [])
		set_photo_base64('')
		set_image_base64([])

	};

	const uploadFilesImage = async (files, order, type, langid, lang) => {

		let aux = []
		files.forEach(async (element) => {
			if (element.type.includes('image/')) {
				aux.push(element)

				let y = img_loader
				y.push('img')
				set_img_loader(y)

				await uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const onChangeHandlerFilesPDF = (e) => {
		const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
				storedFiles.push(v);

				let aux2 = files_doc_name
				if (aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({ name: v.name, size: v.size })
				set_files_doc_name(aux2)

				let aux_doc_cv = treeDataCV
				if (treeDataCV[order] === undefined)
					treeDataCV[order] = []
				if (treeDataCV[order][langid] === undefined)
					treeDataCV[order][langid] = []
				let i = treeDataCV[order][langid].length
				// Append each newly selected file instead of always overwriting index 0,
				// so multiple files chosen at once are all kept in the tree.
				aux_doc_cv[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
				setTreeDataCV(aux_doc_cv)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				alert(language[lang].upload_file_error + v.name);
			}
		});

		let files_aux = files_doc
		files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
		set_files_doc(files_aux)
	}

	const uploadFilesDoc = async (files, order, type, langid, lang) => {
		let aux = []
		files.forEach((element) => {
			if (element.type === "application/pdf") {
				aux.push(element)

				uploadFile(element, order, type, langid, lang)
					.then(() => {
						//console.log('success')
					})
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		})
	}

	const uploadFile = async (file, order, type, langid, lang) => {
		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'content')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/content/');

		console.log('api_crud_base', api_crud_base)
		console.log('formData', formData)

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				let i = Date.now()

				let x = {
					id: i,
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}

				if (type === 'photo') {
					dados.current.info.foto = [
						{
							name: file.name,
							type: file.type,
							size: file.size,
							path: res.data.path,
							source_name: res.data.name,
							link: res.data.path + '' + res.data.name,
						},
					];
				}
				else if (type === 'cv') {
					dados.current.info.cv = [
						{
							name: file.name,
							type: file.type,
							size: file.size,
							path: res.data.path,
							source_name: res.data.name,
							link: res.data.path + '' + res.data.name,
						},
					];
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => {

						let y2 = img_loader
						y2.pop()
						set_img_loader(y2)
						setRefresh(i)

					})
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const change_lang = (l) => {
		set_language(l)
		set_lang(l)

		//console.log('language', localStorage.getItem('lang'))
		//console.log('localstorage', localStorage)
	}

	const handleUserTypeChange = (e) => {
		const selectedValue = e.target.value;
		setSelectedUserTypeId(selectedValue);

		let profile_filter = app_profiles.current.filter(el => parseInt(el.id) === parseInt(selectedValue))

		if (Array.isArray(profile_filter) && profile_filter.length > 0) {
			let aux = {
				id: selectedValue,
				name: profile_filter[0].name
			}

			set_dados(dados.current.profile = aux)
		}
	};

	const handleUserTypeEntityFunctionsChange = (e) => {
		const selectedValue = e.target.value;

		if (!Array.isArray(dados.current.info.attributes.entity_function)) {
			dados.current.info.attributes.entity_function = []
		}
		// entity_function stores plain id values (strings), so dedupe against the value itself,
		// not against a non-existent .id property (this previously let duplicates pile up).
		let aux = dados.current.info.attributes.entity_function.filter(el => parseInt(el) !== parseInt(selectedValue))
		aux.push(selectedValue)

		set_dados(dados.current.info.attributes.entity_function = aux);
	};

	const handleUserTypeEntityRemove = (id) => {

		Swal.fire({
			title: language[lang].remove_title,
			text: language[lang].remove_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: color.corPrimaria.rgb,
			cancelButtonColor: color.corVermelha.rgb,
			confirmButtonText: language[lang].remove_confirm,
			cancelButtonText: language[lang].remove_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					if (Array.isArray(dados.current.info.attributes.entity_function) && dados.current.info.attributes.entity_function.length > 0) {
						let aux = dados.current.info.attributes.entity_function.filter(el => parseInt(el) !== parseInt(id))
						set_dados(dados.current.info.attributes.entity_function = aux);
					}
					else {
						set_dados(dados.current.info.attributes.entity_function = []);
					}

				}
			})

	}
	/// DEPARTAMENTOS ///////////////////////////////////////////////////

	const handleCloseModal = () => {
		setModalDetalhes(false);
		setDepartamentoSelecionado(null);
	};

	const handleSaveChanges = () => {
		if (!selectedDepartamento) {
			console.error("No department selected to update.");
			return;
		}

		const updatedDepartamentos = [...dados.current.contacts[0].departamentos];
		const departamentoIndex = updatedDepartamentos.findIndex(dep => dep.id === selectedDepartamento.id);

		if (departamentoIndex !== -1) {
			updatedDepartamentos[departamentoIndex] = { ...selectedDepartamento };

			dados.current.contacts[0].departamentos = updatedDepartamentos;

			set_dados(prevDados => ({
				...prevDados,
				contacts: [{
					...prevDados.contacts[0],
					departamentos: updatedDepartamentos
				}]
			}));

		} else {
			console.error("Department not found for update:", selectedDepartamento);
		}
		setModalDetalhes(false);
	};

	const handleAddDepartamento = () => {
		// Ensure departamentos is initialized as an array
		if (!dados.current.contacts[0].departamentos) {
			dados.current.contacts[0].departamentos = [];
		}

		// Calculate new ID for departamento
		const departamentos = dados.current.contacts[0].departamentos;
		const departamentoExists = departamentos.some(dep => dep.name.toLowerCase() === departamentoInput.toLowerCase());

		if (departamentoExists) {
			alert("O departamento já existe.");
			return;
		}

		const newId = departamentos.length > 0 ? departamentos[departamentos.length - 1].id + 1 : 1;

		// Create the new departamento object
		const newDepartamento = { id: newId, name: departamentoInput, responsaveis: [] };

		// Push the new departamento to both dados.current and data_interface
		dados.current.contacts[0].departamentos.push(newDepartamento);

		// Clear the input and close the modal
		setDepartamentoInput('');
		setModalDepartamento(false);
	};

	////////////////////////////////////////////////////////
	const handleAddResponsavel = () => {
		// Verifica se há um departamento selecionado
		if (!selectedDepartamentoId) {
			alert("Selecione um departamento antes de adicionar um responsável.");
			return;
		}

		// Garante que contacts é um array válido
		const contatos = dados.current.contacts || [];
		if (contatos.length === 0) {
			alert("Nenhum contato disponível.");
			return;
		}

		// Pega o array de departamentos do primeiro contato
		const departamentos = contatos[0]?.departamentos || [];

		// Encontra o departamento selecionado
		const departamentoIndex = departamentos.findIndex(dep => dep.id === parseInt(selectedDepartamentoId));
		if (departamentoIndex === -1) {
			alert("Departamento não encontrado.");
			return;
		}

		// Calcula um novo ID para o responsável
		const responsaveis = departamentos[departamentoIndex]?.responsaveis || [];
		const newResponsavelId = responsaveis.length > 0 ? responsaveis[responsaveis.length - 1].id + 1 : 1;

		// Cria o novo responsável
		const newResponsavel = {
			id: newResponsavelId,
			nome: responsavelInputNome,
			email: responsavelInputEmail,
			telefone: responsavelInputTel
		};

		// Adiciona o novo responsável ao departamento
		departamentos[departamentoIndex].responsaveis.push(newResponsavel);

		// Atualiza a estrutura de dados
		set_dados(prevDados => ({
			...prevDados,
			contacts: prevDados.contacts ? [{
				...prevDados.contacts[0],
				departamentos: [...departamentos]
			}] : []
		}));

		// Limpa os inputs e fecha o modal
		setResponsavelInputNome('');
		setResponsavelInputEmail('');
		setResponsavelInputTel('');
		setModalResponsavel(false);

	};

	const handleRemoveDepartamento = (departamentoId) => {
		// Ensure departamentos is initialized as an array
		if (!dados.current.contacts[0].departamentos) {
			dados.current.contacts[0].departamentos = [];
		}

		// Filter out the departamento with the specified ID
		const updatedDepartamentos = dados.current.contacts[0].departamentos.filter(
			(departamento) => departamento.id !== departamentoId
		);

		// Update the dados.current and data_interface
		dados.current.contacts[0].departamentos = updatedDepartamentos;

	};

	const mostrarDetalhes = (departamentoId) => {
		setModalDetalhes(true);
		const departamento = dados.current.contacts[0].departamentos.find(depart => depart.id === departamentoId);
		if (departamento) {
			setSelectedDepartamento(departamento);
		}
	};
	/////////////////////////////////////////////////////////////////////////////////////////////////////

	const change_country = e => {

		set_cities([])
		set_villages([])

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = '');

		if (e.value === "Portugal") {

			set_show_district_city_village('')

			if (districts.length === 0) {
				obter_distritos_pt(set_districts)
			}
		}
		else {
			set_show_district_city_village('d-none')
		}

		set_dados(dados.current.addresses[0].country = e.value);
	}

	const change_district = e => {

		set_cities([])
		set_villages([])

		obter_cidades_por_distrito(e.value, set_cities)

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = e.value);
	}

	const change_city = e => {
		set_villages([])
		obter_freguesias_por_cidade(e.value, set_villages)
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].city = e.value);
	}

	const change_village = e => {
		set_dados(dados.current.addresses[0].village = e.value);
		set_dados(dados)
	}

	
	const change_ocupacao_country = e => {

		if(dados.current.info.ocupacao === undefined) {
			dados.current.info.ocupacao = {}
		}

		set_cities([])
		set_villages([])

		set_dados(dados.current.info.ocupacao.city = '');
		set_dados(dados.current.info.ocupacao.village = '');
		set_dados(dados.current.info.ocupacao.region = '');

		if (e.value === "Portugal") {

			set_show_district_city_village('')

			if (districts.length === 0) {
				obter_distritos_pt(set_districts)
			}
		}
		else {
			set_show_district_city_village('d-none')
		}

		set_dados(dados.current.info.ocupacao.country = e.value);
	}

	const change_ocupacao_district = e => {

		if(dados.current.info.ocupacao === undefined) {
			dados.current.info.ocupacao = {}
		}

		set_cities([])
		set_villages([])

		obter_cidades_por_distrito(e.value, set_cities)

		set_dados(dados.current.info.ocupacao.city = '');
		set_dados(dados.current.info.ocupacao.village = '');
		set_dados(dados.current.info.ocupacao.region = e.value);
	}

	const change_ocupacao_city = e => {

		if(dados.current.info.ocupacao === undefined) {
			dados.current.info.ocupacao = {}
		}

		set_villages([])
		obter_freguesias_por_cidade(e.value, set_villages)
		set_dados(dados.current.info.ocupacao.village = '');
		set_dados(dados.current.info.ocupacao.city = e.value);
	}

	const change_ocupacao_village = e => {

		if(dados.current.info.ocupacao === undefined) {
			dados.current.info.ocupacao = {}
		}

	set_dados(dados.current.info.ocupacao.village = e.value);
		set_dados(dados)
	}

	const change_entity_type_multi = (selected) => {
		const ids = Array.isArray(selected) ? selected.map(s => s.value) : [];
		set_dados(entity_nature_filter.current = entity_nature.current.filter(el =>
			ids.some(id => parseInt(el.parent) === parseInt(id))
		));
		set_dados(entity_profiles_filter.current = entity_profiles.current.filter(el =>
			ids.some(id => parseInt(el.settings?.entity_type) === parseInt(id))
		));

		if (dados.current.info.attributes === undefined) {
			dados.current.info.attributes = {};
		}
		set_dados(dados.current.info.attributes.entity_type = ids);
	};

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				if (res.data[0].contacts[0].email === '') {
					res.data[0].contacts[0].email = res.data[0].info.email
				}

				let aux_doc_cv = []
				let i = 0
				console.log('res.data[0].info.cv', res.data[0].info.cv)

				if (!Array.isArray(res.data[0].info.cv)) {
					res.data[0].info.cv = []
				}

				if (res?.data[0]?.info?.cv !== undefined) {
					res.data[0].info.cv.forEach((el, k) => {

						aux_doc_cv = []
						aux_doc_cv[k] = []
						aux_doc_cv[k][1] = []

						aux_doc_cv[k][1].push({ id: ++i, id_doc: el.id, title: el.name, link: el.link, visible: el.visible })
					})
					console.log('res.data[0].info.cv', res.data[0].info.cv)
				}
				console.log('aux_doc_cv', aux_doc_cv)
				setTreeDataCV(aux_doc_cv)

				set_dados(dados.current = res.data[0]);
				console.log('Data', res)
				setSelectedSoftware(res.data[0].info.departamento.software || []);
				setTag(res.data[0].info.tag || '')
			})
			.catch(error => console.log(error))
	}

	////////////////////////////////////////////// VAI BUSCAR O TIPO DE UTILIZADOR /////////////////////////////////////

	const checkDepartmento = (id) => {
		if (dados.current && dados.current.info && Array.isArray(dados.current.info.departamento)) {
			return dados.current.info.departamento.some(el => el.id === id);
		}
		return false;
	};

	const escolheDepartamentos = (id) => {
		let updatedSelecionado;

		if (!Array.isArray(dados.current.info.departamento)) {
			dados.current.info.departamento = [];
		}

		if (checkDepartmento(id)) {
			updatedSelecionado = dados.current.info.departamento.filter(dept => dept.id !== id);
		} else {
			const selectedDept = departamentos.find(dept => dept.id === id);
			if (selectedDept) {
				updatedSelecionado = [...dados.current.info.departamento, selectedDept];
			}
		}

		dados.current.info.departamento = updatedSelecionado;
		set_dados(dados.current);
		setDepartamentoSelecionado(updatedSelecionado);
	};

	const checkSoftware = (departmentId, softwareId) => {
		if (selectedSoftware[departmentId]?.includes(softwareId)) {
			return true;
		}

		if (dados.current && dados.current.info && Array.isArray(dados.current.info.departamento)) {
			const department = dados.current.info.departamento.find(dept => dept.id === departmentId);

			if (department && Array.isArray(department.software)) {
				return department.software.includes(softwareId);
			}
		}

		return false;
	};

	const escolheSoftware = (departmentId, softwareId) => {
		setSelectedSoftware(prev => {
			const departmentSoftware = prev[departmentId] || [];
			const updatedDepartmentSoftware = departmentSoftware.includes(softwareId)
				? departmentSoftware.filter(id => id !== softwareId)
				: [...departmentSoftware, softwareId];

			return {
				...prev,
				[departmentId]: updatedDepartmentSoftware
			};
		});
	};

	const removeSoftware = (departamentoId, softwareId) => {
		setDepartamentos(prevDepartamentos =>
			prevDepartamentos.map(departamento =>
				departamento.id === departamentoId
					? {
						...departamento,
						software: departamento.software.filter(software => software.id !== softwareId)  // Remove the software by id
					}
					: departamento
			)
		);
	};

	///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	useEffect(() => {

		if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
			change_lang('pt')
		}
		else {
			set_lang(localStorage.getItem('lang'))
			console.log("estamos a alterar para", lang)
		}

	}, [props])

	useEffect(() => {
		if (!Array.isArray(dados.current.info.relacao)) {
			dados.current.info.relacao = [];
		}
	}, []);

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)

		//console.log(dados.current)
	}

	const fetch_entity_attributes = async (type) => {

		let res = await reqGET(`${api_crud_base}/entities/attributes/type/${getTokenInfo().companycode}/${type}`)
		let result = []
		if (res.data !== undefined) {
			for await (let el of res.data) {
				let aux = {
					id: el.id,
					name: translate(el.info.name, 'pt'),
					type: el.info.type,
					parent: el.info.parent
				}

				result.push(aux)
			}

			if (type === 'entity_relation') {
				set_dados(entity_relation_raw.current = res.data)
			}
		}

		return result

	}

	const order_array = (array) => {

		return array.sort((a, b) => {
			const nameA = a.name.toUpperCase(); // ignore upper and lowercase
			const nameB = b.name.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}

	useEffect(() => {
		const fetchData = async () => {
			try {
				// Reset data before refetching
				set_dados(entity_profiles.current = []);
				set_dados(app_profiles.current = []);
				set_dados(entity_type.current = []);
				set_dados(entity_nature.current = []);
				set_dados(entity_function.current = []);
				set_dados(entity_relation.current = []);

				const companyCode = getTokenInfo().companycode;
				const profile = getTokenInfo().profile;
				const entityProfiles = getTokenInfo().entity_profile || [];

				// Fetch profiles
				const [resEntities, resProfiles] = await Promise.all([
					reqGET(`${Hosts.SIMCore_API}/entities/profiles/${companyCode}`),
					reqGET(`${Hosts.SIMCore_API}/profiles/${companyCode}`)
				]);

				setUserTypesEntities(resEntities.data);
				setUserTypes(resProfiles.data);
				set_dados(entity_profiles.current = resEntities.data);
				set_dados(app_profiles.current = resProfiles.data);

				// Helper to fetch and transform attributes
				const fetchAndSetEntityAttr = async (key, target) => {
					let res = await fetch_entity_attributes(key);
					if (res.length > 0) {
						res = order_array(res);
						const mapped = res.map(el => ({
							id: el.id,
							label: el.name,
							parent: el.parent
						}));
						set_dados(target.current = mapped);
					}
				};

				// Fetch all entity attributes
				await Promise.all([
					fetchAndSetEntityAttr('entity_category', entity_category),
					fetchAndSetEntityAttr('entity_type', entity_type),
					fetchAndSetEntityAttr('entity_nature', entity_nature),
					fetchAndSetEntityAttr('entity_function', entity_function),
					fetchAndSetEntityAttr('entity_relation', entity_relation),
				]);

				// Ensure attribute structure
				if (!dados.current.info.attributes) {
					dados.current.info.attributes = {};
				}

				// Define entity_category value dynamically ('1' or '2')
				const categoryValue = '1'
				set_dados(dados.current.info.attributes['entity_category'] = categoryValue);

				// Filters based on entity_type
				const entityTypeVal = dados.current.info.attributes.entity_type;
				if (entityTypeVal) {
					set_dados(entity_nature_filter.current = entity_nature.current.filter(el => parseInt(el.parent) === parseInt(entityTypeVal)));
				}

				// Listas completas — entity_profile, entity_type, entity_function e entity_relation
				// já não são filtradas por entity_category, ficam disponíveis para
				// entidades internas e externas
				set_dados(entity_profiles_filter.current = entity_profiles.current);
				set_dados(entity_type_filter.current = entity_type.current);
				set_dados(entity_function_filter.current = entity_function.current);
				set_dados(entity_relation_filter.current = entity_relation.current);

				// Sidebar permissions
				await UseSidebar().getSidebar(profile).then(async (sidebar) => {
					await get_permissions(pathname, sidebar);
				});

				for await (let el of entityProfiles) {
					await UseSidebar().getSidebarEntity(el.name).then(async (v) => {
						await get_permissions(pathname, v);
					});
				}

				console.log('Dados final:', dados.current);
				console.log('Permissões finais:', permissions.current);
			} catch (error) {
				console.error("Erro ao carregar dados iniciais:", error);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, [pathname]);

	useEffect(() => {
		clean_data();
		obter_paises_em_pt(set_countries);

		if (getTokenInfo().profile === 'Cliente') {

			set_is_edit(true)

			set_show_delete_button('d-none')

			fetch_id_info(getTokenInfo().id).then(() => {

				if (dados.current.addresses[0].country === 'Portugal') {

					obter_distritos_pt(set_districts)

					obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

					if(dados.current.addresses[0].city !== '') {
						obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
					}
				}
				else {
					set_show_district_city_village('d-none')
				}
			})
			return

		}

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {

				//console.log('000')

				//console.log('NO EDIT')
				set_is_edit(true)

				set_show_delete_button('')

				fetch_id_info(props.location.state.item['id']).then(() => {

					//console.log(dados.current)
					if (dados.current.addresses[0].country === 'Portugal') {

						obter_distritos_pt(set_districts)

						obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

						if(dados.current.addresses[0].city !== '') {
							obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
						}
					}
					else {
						set_show_district_city_village('d-none')

					}
				})
				return
			}
		}
		catch {

			clean_data()


			setRedirect(false);
			return

		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

	}, [props])

	const fetch_clube = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Clube`);
			// value/label é o formato que o react-select espera; guardamos id/name (ver change_clube)
			const clubesOptions = res.data.map(clube => ({
				value: clube.id,
				label: clube.name,
			}));
			setClubes(clubesOptions);
		} catch (error) {
			console.error("Erro ao buscar os clubes:", error);
		}
	};

	const fetch_departamentos = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/intranet/departments/${getTokenInfo().companycode}`);
			const departamentoOptions = res.data.map(departamento => ({
				id: departamento.id,
				name: departamento.info.name,
				software: departamento.info.selectedTypes
			}));
			setDepartamentos(departamentoOptions);
		} catch (error) {
			console.error("Erro ao buscar os departamentos:", error);
		}
	};

	const fetch_colaboradores = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Colaborador`);
			const colaboradoresOptions = res.data.map(colaborador => ({
				id: colaborador.id,
				name: colaborador.name,
				departamento: colaborador.departamento?.map(departamento => ({
					id: departamento.id,
					name: departamento.name,
				})) || [],
				email: colaborador.email
			}));
			setAllResponsaveis(colaboradoresOptions);
		} catch (error) {
			console.error("Erro ao buscar os colaboradores:", error);
		}
	};

	const fetch_teamleaders = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/TeamLeader`);
			const teamLeaderOptions = res.data.map(teamLeader => ({
				id: teamLeader.id,
				name: teamLeader.name,
				departamento: teamLeader.departamento?.map(departamento => ({
					id: departamento.id,
					name: departamento.name,
				})) || [],
				email: teamLeader.email
			}));
			setTeamLeader(teamLeaderOptions);
		} catch (error) {
			console.error("Erro ao buscar os TeamLeaders:", error);
		}
	};
	// Group colaboradores and team leaders by departamento
	const groupColaboradoresByDepartamento = (colaboradores, teamLeaders) => {
		const departamentoMap = new Map();

		const addToDepartamento = (dep, type, person) => {
			if (!departamentoMap.has(dep.id)) {
				departamentoMap.set(dep.id, {
					name: dep.name,
					colaboradores: [],
					teamLeaders: []
				});
			}
			departamentoMap.get(dep.id)[type].push(person);
		};

		colaboradores.forEach(colaborador => {
			if (colaborador.departamento && Array.isArray(colaborador.departamento)) {
				colaborador.departamento.forEach(dep => {
					addToDepartamento(dep, "colaboradores", {
						id: colaborador.id,
						name: colaborador.name,
						email: colaborador.email
					});
				});
			} else {
				console.warn(`Colaborador ${colaborador.name} has no valid departamento data.`);
			}
		});

		teamLeaders.forEach(teamLeader => {
			if (teamLeader.departamento && Array.isArray(teamLeader.departamento)) {
				teamLeader.departamento.forEach(dep => {
					addToDepartamento(dep, "teamLeaders", {
						id: teamLeader.id,
						name: teamLeader.name,
						email: teamLeader.email
					});
				});
			} else {
				console.warn(`Team leader ${teamLeader.name} has no valid departamento data.`);
			}
		});

		const result = Array.from(departamentoMap.entries()).reduce((acc, [id, data]) => {
			acc[id] = data;
			return acc;
		}, {});

		return result;
	};

	// Fetch both departamentos and colaboradores and process the data
	const fetchAndDisplayData = async () => {
		await fetch_clube();
		await fetch_departamentos();
		await fetch_colaboradores();
		await fetch_teamleaders();
	};

	useEffect(() => {
		fetchAndDisplayData();
	}, []);

	useEffect(() => {
		if (dados.current.info.departamento) {
			const initialSelections = {};
			dados.current.info.departamento.forEach(department => {
				initialSelections[department.id] = department.software
					? department.software.map(software => software.id)
					: [];
			});
			setSelectedSoftware(initialSelections);
		}
	}, [dados.current.info.departamento]);


	function atualizarNotificacaoDiaria() {
		const dataHoje = new Date().toISOString().split('T')[0];

		if (dados.current.info.entity?.some(option => option.label === 'Interna') || selectedColaborador === '1') {
			if (dados.current.info.notify?.lastUpdated !== dataHoje) {
				const jsonData = {
					dataAtual: new Date().toISOString(),
					tarefas: [],
					lastUpdated: dataHoje
				};
				return jsonData;
			}
		}

		return null;
	}

	useEffect(() => {
		if (is_edit) {
			setShowOverview(true);
			setShowFunctions(false);
		}
	}, [is_edit]);

	// Se o separador "Pais e Encarregados de Educação" estiver ativo e a entidade
	// deixar de ser menor de idade (ex: data de nascimento foi alterada), sai desse separador.
	useEffect(() => {
		if (showGuardians && !is_minor) {
			selectTab('overview');
		}
	}, [is_minor, is_selecionado]);

	const handleSubmit = async (e) => {
		e.preventDefault();

		// dados.current.profile.id = dados.current.id;
		dados.current.info.notify = atualizarNotificacaoDiaria();
		// dados.current.info.entity_type = dados.current.info?.entity[0]?.id || null;
		dados.current.info.birthday = dados.current.info.birthday || null;
		dados.current.info.username = dados.current.info.username || dados.current.info.razaoSocial;
		dados.current.info.tag = dados.current.info.tag || tag;


		const departamentosToSubmit = Array.isArray(dados.current.info.departamento)
			? dados.current.info.departamento.map(departamento => {
				const selectedSoftwareIds = selectedSoftware[departamento.id] || [];

				const softwareArray = Array.isArray(departamento.software)
					? departamento.software
						.filter(software => selectedSoftwareIds.includes(software.id))
						.map(software => ({
							id: software.id,
							nome: software.nome,
						}))
					: [];

				return {
					id: departamento.id,
					name: departamento.name,
					software: softwareArray,
				};
			})
			: [];

		dados.current.info.departamento = departamentosToSubmit;

		const requestMethod = is_edit ? reqPUT : reqPOST;
		const apiRoute = api_crud_route;

		try {
			const response = await requestMethod(apiRoute, dados.current);
			console.log("Response:", response);
			set_new_password('');
			set_confirm_password('');

			files_image.forEach(async (el_image) => {
				if (el_image !== null) {
					if (el_image.files.length > 0) {
						await uploadFilesImage(el_image.files, el_image.order, 'photo', el_image.langid, el_image.lang)
					}
				}
			})
			set_files_image([])
			set_image_base64([])
			// set_photo_base64('')

			files_doc.forEach(async (el_doc) => {
				if (el_doc !== null) {
					await uploadFilesDoc(el_doc.files, el_doc.order, 'cv', el_doc.langid, el_doc.lang)
				}
			})
			set_files_doc([])
			set_files_doc_name([])


			if (is_edit) {
				Swal.fire('', 'Atualizado com sucesso', 'success');
			}
			else {
				props.history.push(endpoints.list);
				// window.location.reload();
			}

		} catch (error) {
			console.error("Submission error:", error);
			const errorMsg = is_edit ? language[lang].edit_error : language[lang].insert_error;
			Swal.fire('', errorMsg, 'info');
		}

	};

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: color.corPrimaria.rgb,
			cancelButtonColor: color.corVermelha.rgb,
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
	}

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: color.corPrimaria.rgb,
			cancelButtonColor: color.corVermelha.rgb,
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					reqDELETE(api_crud_route + '/', { id: dados.current.id })
						.then(res => {
							props.history.push(endpoints.list);
						})
						.catch(error => alert(error))

				}
			})
	};

	const load_entity = async (vat, entity) => {
		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`)
			.then(res => {
				let ja_existe = false
				res.data.forEach((k) => {
					if (k['vat'] === vat) {
						ja_existe = true
					}
				})

				if (ja_existe === false) {
					return
				} else {
					Swal.fire('Já Existe um Registo com este VAT.', '', 'info')
				}
			}
			)
	}

	const handle_change_addresses = (e, addresses_index = 0) => {
		const { name, value } = e.target;
		set_dados(dados.current.addresses[addresses_index][name] = value)
	}

	const handle_categoria_change = (id) => {
		const atual = dados.current.info.categoria ?? [];
		const novo = atual.includes(id) ? atual.filter(c => c !== id) : [...atual, id];
		set_dados(dados.current.info.categoria = novo);
	};

	const handle_programa_change = (id) => {
		const atual = dados.current.info.programas ?? [];
		const novo = atual.includes(id) ? atual.filter(p => p !== id) : [...atual, id];
		set_dados(dados.current.info.programas = novo);
	};

	const handle_projeto_change = (id) => {
		const atual = dados.current.info.projetos ?? [];
		const novo = atual.includes(id) ? atual.filter(p => p !== id) : [...atual, id];
		set_dados(dados.current.info.projetos = novo);
	};

	const handle_change_encarregados = (pessoa, campo, valor) => {
		const atual = dados.current.info.encarregados ?? {};
		set_dados(dados.current.info.encarregados = {
			...atual,
			[pessoa]: { ...atual[pessoa], [campo]: valor },
		});
	};

	const modalidades_lista = [
		{ value: 'ski_de_fundo', label: 'Esqui de Fundo' },
		{ value: 'curling', label: 'Curling' },
		{ value: 'ski_alpino', label: 'Esqui alpino' },
		{ value: 'bobsled', label: 'Bobsled' },
		{ value: 'hoquei_no_gelo', label: 'Hóquei no gelo' },
		{ value: 'luge', label: 'Luge' },
		{ value: 'snowboard', label: 'Snowboard' },
		{ value: 'skeleton', label: 'Skeleton' },
		{ value: 'patinagem_artistica', label: 'Patinagem artística' },
		{ value: 'patinagem_de_velocidade', label: 'Patinagem de velocidade' },
		{ value: 'ski_freestyle', label: 'Esqui Free Style' },
		{ value: 'biatlo', label: 'Biatlo' },
	];

	// Multi-select de clubes (à semelhança de change_modalidades), mas guardando
	// {id, name} em vez de {value, label} — mais direto para consumir noutros sítios do código.
	const change_clube = (selected) => {
		const value = Array.isArray(selected)
			? selected.map(s => ({ id: s.value, name: s.label }))
			: [];

		set_dados(dados.current.info.clube = value);
	};

	const change_modalidades = (selected) => {
		set_dados(dados.current.info.modalidades = selected || []);
	};

	const handle_change_info = (e) => {
		const { name, value } = e.target;
		const formattedValue = value;

		set_dados(dados.current.info[name] = formattedValue);

		if (name === 'razaoSocial') {
			dados.current.info.username = formattedValue;
		}
		if (name === 'type') {
			dados.current.profile.name = formattedValue;
		}
		if (!is_edit && name === 'vat') {
			if (dados.current.info['vat'].length === 9) {
				load_entity(dados.current.info['vat'], object_type);
			}
		}
	};
	
		// Campos que vivem em info.identificacao (tipo_identificacao, numero_identificacao,
		// validade_identificacao, iban, nbss, ass, arquivo, validade_contribuinte).
		// O vat/NIF fica de fora deste objeto e continua a usar handle_change_info.
		const handle_change_identificacao = (e) => {
			const { name, value } = e.target;
			let formattedValue = value;
	
			if (name === 'validade_contribuinte' || name === 'validade_identificacao') {
				const digits = value.replace(/\D/g, '');
	
				if (digits.length <= 2) {
					formattedValue = digits;
				} else {
					formattedValue = digits.slice(0, 2) + '/' + digits.slice(2, 4);
				}
			}
	
			if (!dados.current.info.identificacao) {
				dados.current.info.identificacao = {};
			}
	
			set_dados(dados.current.info.identificacao[name] = formattedValue);
		};

	const handle_change_info_ocupacao = (e) => {
			const { name, value } = e.target;
			let formattedValue = value;
	
			if (!dados.current.info.ocupacao) {
				dados.current.info.ocupacao = {};
			}
	
			set_dados(dados.current.info.ocupacao[name] = formattedValue);

			console.log('dados.current.info.ocupacao', dados.current.info.ocupacao)
			setRefresh(r => r + 1)
			
		};

	const handle_change_login = (e) => {
		const { value } = e.target;

		load_entity('username', value, '')
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;
		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;
		if (new_password !== '' && value === new_password) {
			set_dados(dados.current.info.password = passwordHash(new_password))
			set_disabled(false)
		}
		else {
			Swal.fire('Password de confirmação diferente da password inserida.', '', 'info')
			set_disabled(true)
		}
	}

	const handle_change_contacts = (e, index = 0) => {
		const { name, value } = e.target;
		set_dados(dados.current.contacts[index][name] = value)
	}

	const change_entity_attributes = (e) => {
		const { name, value } = e.target;

		if (name === 'entity_category') {
			set_dados(entity_type_filter.current = entity_type.current.filter(el => parseInt(el.parent) === parseInt(value)))
			set_dados(entity_profiles_filter.current = entity_profiles.current.filter(el => parseInt(el.parent) === parseInt(value)))
			set_dados(entity_relation_filter.current = entity_relation.current.filter(el => parseInt(el.parent) === parseInt(value)))
			set_dados(entity_nature_filter.current = [])
			set_dados(dados.current.info.relacao = [])
		}
		else if (name === 'entity_type') {
			set_dados(entity_nature_filter.current = entity_nature.current.filter(el => parseInt(el.parent) === parseInt(value)))

			set_dados(entity_profiles_filter.current = entity_profiles.current.filter(el => parseInt(el.settings.entity_type) === parseInt(value)))
		}
		else if (name === 'entity_nature') {
			set_dados(entity_profiles_filter.current = entity_profiles.current.filter(el => parseInt(el.settings.entity_nature) === parseInt(value)))
		}

		if (dados.current.info.attributes === undefined) {
			dados.current.info.attributes = {}
		}

		set_dados(dados.current.info.attributes[name] = value)

	}

	const change_entity_profile_multi = (selected) => {
		const value = Array.isArray(selected)
			? selected.map(s => ({ id: s.value, label: s.label }))
			: [];

		if (dados.current.info.attributes === undefined) {
			dados.current.info.attributes = {}
		}

		set_dados(dados.current.info.attributes['entity_profile'] = value)
	}

	const handle_entity_relation = (e) => {
		const { value, checked } = e.target;

		if (!dados.current.info.relacao) {
			dados.current.info.relacao = [];
		}

		const selectedOption = entity_relation.current.find(option => parseInt(option.id) === parseInt(value));

		if (checked && selectedOption) {
			if (!dados.current.info.relacao.some(item => parseInt(item) === parseInt(value))) {
				set_dados(dados.current.info.relacao.push(selectedOption.id))
			}
		}
		else {
			set_dados(dados.current.info.relacao = dados.current.info.relacao.filter(item => parseInt(item) !== parseInt(value)))
		}
	};

	const open_link = (url) => {
		window.open(url, '_blank');
	}

	const copy_clipboard = (url) => {
		navigator.clipboard.writeText(url)

		Swal.fire({
			icon: '',
			title: '',
			text: 'Copiado',
			showConfirmButton: false,
			timer: 1000
		})
	}

	const handle_change_tree = (tD, order, langid) => {

		treeDataCV[order][langid] = tD

		let aux = []
		if (langid === '1') {
			treeDataCV[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeDataCV(treeDataCV)
		}
		else {
			treeDataCV[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if (el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeDataCV(treeDataCV)
		}
	}

	const remove_element_tree_cv = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					let treeAux = treeDataCV[order][langid].filter(v => v.id !== id)
					treeDataCV[order][langid] = treeAux
					setTreeDataCV(treeDataCV)

					let aux = []
					if (langid === '1') {
						dados.current.info.cv.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.info.cv = aux)
					}
					else {
						dados.current.info['language'][langid].cv.forEach((el) => {
							if (el.id !== doc)
								aux.push(el)
						})
						set_dados(dados.current.info['language'][langid].cv = aux)
					}

				}
			})
	}

	const edit_element_tree = (e) => {
		const { value, dataset } = e.target;
		const { order, id, /*doc,*/ link } = dataset

		treeDataCV[order].forEach((child) => {
			child.forEach((el) => {
				if (el.id === id) {
					el.title = value

					dados.current.content[order].media.doc.forEach((el_2) => {
						if (el_2.link === link) {
							el_2.name = value
						}
					})
				}
			})
		})
		setTreeDataCV(treeDataCV)
		set_dados(dados.current.content[order],)
	}

	const get_entity_function = (id) => {

		let result = ''
		if (id !== '') {
			let aux = entity_function.current.filter(e => parseInt(e.id) === parseInt(id))
			if (Array.isArray(aux) && aux.length > 0) {
				result = aux[0].label
			}

		}
		return result

	}

	let get_permissions = async (e, sidebar) => {
		let handleSingleCheck = async (e, sidebar) => {
			const name = e;

			let ver_submenu = async (node) => {
				if (node.submenu.length !== 0) {
					for await (let subitem of node.submenu) {

						let name_aux = name.split('_')
						name_aux.pop()
						name_aux = name_aux.join('_')

						if (subitem.path === name || subitem.path.includes(name_aux)) {

							let aux = {}
							if (permissions.current !== null) {
								aux = permissions.current

								if (aux.create !== true) {
									aux.create = subitem.create
								}
								if (aux.edit !== true) {
									aux.edit = subitem.edit
								}
								if (aux.remove !== true) {
									aux.remove = subitem.remove
								}
								if (aux.identificacao !== true) {
									aux.identificacao = subitem.identificacao
								}
								if (aux.naturalidade !== true) {
									aux.naturalidade = subitem.naturalidade
								}
								if (aux.fiscal !== true) {
									aux.fiscal = subitem.fiscal
								}
								if (aux.contrato !== true) {
									aux.contrato = subitem.contrato
								}
								if (aux.funcoes !== true) {
									aux.funcoes = subitem.funcoes
								}
								if (aux.configuracoes !== true) {
									aux.configuracoes = subitem.configuracoes
								}
							}
							else {
								aux = {
									create: subitem.create,
									edit: subitem.edit,
									view: true,
									remove: subitem.remove,

									identificacao: subitem.identificacao,
									naturalidade: subitem.naturalidade,
									fiscal: subitem.fiscal,
									contrato: subitem.contrato,
									funcoes: subitem.funcoes,
									configuracoes: subitem.configuracoes
								}
							}

							set_dados(permissions.current = aux)
						}
						else {
							await ver_submenu(subitem)
						}

					}
				}
			}

			for await (let node of sidebar) {

				let name_aux = name.split('_')
				name_aux.pop()
				name_aux = name_aux.join('_')


				if (node.path === name || node.path.includes(name_aux)) {

					let aux = {}
					if (permissions.current !== null) {
						aux = permissions.current

						if (aux.create !== true) {
							aux.create = node.create
						}
						if (aux.edit !== true) {
							aux.edit = node.edit
						}
						if (aux.remove !== true) {
							aux.remove = node.remove
						}
					}
					else {
						aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
					}

					set_dados(permissions.current = aux)

					if (Array.isArray(node.submenu) && node.submenu.length > 0) {
						await ver_submenu(node)
					}

				} else
					await ver_submenu(node)
			}
		}

		await handleSingleCheck(e, sidebar)
	}


	return isloading ?
		<Loader />
		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].entity}</h2>
					<p>{language[lang].entity} / {dados.current.id !== '' ? language[lang].entity_edit : language[lang].entity_new}</p>
				</div>
				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0 d-flex justify-content-sm-between p-4 ">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0 text-nowrap">{language[lang].personal_data}</h3>
										</div>
									</div>
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">
												<div className="tab-content">
													<TabButtons />

													{showOverView && (
														<div className='p-4'>
															<h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].personal_data}</h6>
															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].name}</label>
																	<input type="text" name="name" value={dados.current.info.name || ''} className="form-control rounded-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].birthday}</label>
																	<input type="date" name="birthday" value={dados.current.info.birthday || ''}
																		className="form-control rounded-0"
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].genero}</label>
																	<select
																		name="genero"
																		className="form-select rounded-0"
																		onChange={handle_change_info}
																		value={
																			dados?.current?.info?.genero !== undefined &&
																				dados?.current?.info?.genero !== null
																				? dados.current.info.genero
																				: ''
																		}
																	>
																		<option value="">{language[lang].select}</option>
																		<option value="2">{language[lang].feminino}</option>
																		<option value="1">{language[lang].masculino}</option>
																		<option value="0">{language[lang].outro}</option>
																	</select>
																</div>
															</div>

															<div className="row g-3 mb-4">
																<div className="col-md-6">
																	<label className="form-label fw-bold fs-6">{language[lang].estado_civil}</label>
																	<select
																		name="estado_civil"
																		className="form-select rounded-0"
																		onChange={handle_change_info}
																		value={
																			dados?.current?.info?.estado_civil !== undefined &&
																				dados?.current?.info?.estado_civil !== null
																				? dados.current.info.estado_civil
																				: ''
																		}
																	>
																		<option value="">{language[lang].select}</option>
																		<option value="0">{language[lang].solteiro}</option>
																		<option value="1">{language[lang].casado}</option>
																		<option value="2">{language[lang].divorciado}</option>
																		<option value="3">{language[lang].viuvo}</option>
																	</select>
																</div>

																<div className="col-md-6">
																	<label className="form-label fw-bold fs-6">{language[lang].habilitacao_literaria}</label>
																	<select
																		name="habilitacao_literaria"
																		className="form-select rounded-0"
																		onChange={handle_change_info}
																		value={
																			dados?.current?.info?.habilitacao_literaria !== undefined &&
																				dados?.current?.info?.habilitacao_literaria !== null
																				? dados.current.info.habilitacao_literaria
																				: ''
																		}
																	>
																		<option value="">{language[lang].select}</option>
																		<option value="0">{language[lang].ensino_basico}</option>
																		<option value="1">{language[lang].ensino_secundario}</option>
																		<option value="2">{language[lang].licenciatura}</option>
																		<option value="3">{language[lang].mestrado}</option>
																		<option value="4">{language[lang].doutoramento}</option>
																		<option value="5">{language[lang].pos_doutoramento}</option>
																	</select>
																</div>
															</div>

															<hr className="my-4" />
															<br />
															<h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].contacto}</h6>
															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].tlm}</label>
																	<PhoneInput
																		defaultCountry="PT"
																		className="form-control rounded-0"
																		placeholder={language[lang].tlm_placeholder}
																		value={dados.current.contacts[0].mobile_phone !== '' ? dados.current.contacts[0].mobile_phone : null}
																		onChange={e => set_dados(dados.current.contacts[0].mobile_phone = e)}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].email}</label>
																	<input type="email" pattern={pattern_email} name="email" value={(dados.current.info.email != undefined && dados.current.info.email != '' ? dados.current.info.email : dados.current.contacts[0].email) || ''} className="form-control rounded-0" placeholder={language[lang].email_placeholder} onChange={handle_change_contacts} />
																</div>
															</div>

															<hr className="my-4" />
															<br />
															<h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].morada}</h6>
															<div className="row g-3 mb-4">
																<div className="col-12">
																	<label className="form-label fw-bold fs-6">{language[lang].morada}</label>
																	<textarea name="address_detail" value={dados.current.addresses[0].address_detail} className="form-control rounded-0" rows="3" onChange={handle_change_addresses} />
																</div>
															</div>

															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].local}</label>
																	<input type="text" name="localidade" value={dados.current.addresses[0].localidade || ''} className="form-control rounded-0 py-2" placeholder={language[lang].local_placeholder} onChange={handle_change_addresses} />
																</div>

																<div className={"col-md-4" + (dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
																	<label className="form-label fw-bold fs-6">{language[lang].postal_code}</label>
																	<input type="text" name="postal_code" value={dados.current.addresses[0].postal_code || ''} className="form-control rounded-0 py-2" placeholder={language[lang].postal_code_placeholder} onChange={handle_change_addresses} />
																</div>

																<div className={"col-md-4" + (dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
																	<label className="form-label fw-bold fs-6">{language[lang].village}</label>
																	<Select
																		className="div-select"
																		options={villages}
																		name="freguesia"
																		value={dados.current.addresses[0].village === '' ? null : { label: dados.current.addresses[0].village, value: dados.current.addresses[0].village }}
																		placeholder={language[lang].village_placeholder}
																		onChange={change_village}
																	/>
																</div>

																<div className={"col-md-4" + (dados.current.addresses[0].country.toLowerCase() === 'portugal' ? ' d-none' : '')}>
																	<label className="form-label fw-bold fs-6">{language[lang].country}</label>
																	<Select
																		className="div-select"
																		options={countries}
																		name="pais"
																		value={dados.current.addresses[0].country === '' ? null : { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }}
																		placeholder={language[lang].country_placeholder}
																		onChange={change_country}
																	/>
																</div>
															</div>

															<div className="row g-3 mb-4">
																<div className={"col-md-4" + (dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
																	<label className="form-label fw-bold fs-6">{language[lang].city}</label>
																	<Select
																		className="div-select"
																		options={cities}
																		name="concelho"
																		value={dados.current.addresses[0].city === '' ? null : { label: dados.current.addresses[0].city, value: dados.current.addresses[0].city }}
																		placeholder={language[lang].city_placeholder}
																		onChange={change_city}
																	/>
																</div>

																<div className={"col-md-4" + (dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
																	<label className="form-label fw-bold fs-6">{language[lang].district}</label>
																	<Select
																		className="div-select"
																		options={districts}
																		name="distrito"
																		value={dados.current.addresses[0].region === '' ? null : { label: dados.current.addresses[0].region, value: dados.current.addresses[0].region }}
																		placeholder={language[lang].district_placeholder}
																		onChange={change_district}
																	/>
																</div>

																<div className={"col-md-4" + (dados.current.addresses[0].country.toLowerCase() === 'portugal' ? '' : ' d-none')}>
																	<label className="form-label fw-bold fs-6">{language[lang].country}</label>
																	<Select
																		className="div-select"
																		options={countries}
																		name="pais"
																		value={dados.current.addresses[0].country === '' ? null : { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }}
																		placeholder={language[lang].country_placeholder}
																		onChange={change_country}
																	/>
																</div>
															</div>

															<hr className="my-4" />
															<br />
															<h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].identification_number}</h6>
															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].tipo_identificacao}</label>
																	<select
																		name="tipo_identificacao"
																		className="form-select rounded-0"
																		onChange={handle_change_identificacao}
																		value={dados.current.info.identificacao?.tipo_identificacao ?? ''}
																		required
																	>
																		<option value="">{language[lang].select}</option>
																		<option value="cc">{language[lang].cc}</option>
																		<option value="bi">{language[lang].bi}</option>
																		<option value="ar">{language[lang].autorizacao_residencia}</option>
																		<option value="passaporte">{language[lang].passaporte}</option>
																	</select>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].numero_identificacao}</label>
																	<input
																		type="text"
																		name="numero_identificacao"
																		value={dados.current.info.identificacao?.numero_identificacao ?? ''}
																		className="form-control rounded-0"
																		placeholder={language[lang].numero_identificacao_placeholder}
																		onChange={handle_change_identificacao}
																		required
																	/>
																</div>
																
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].validade_identificacao}</label>
																	<input
																		type="text"
																		minLength="5"
																		maxLength="5"
																		inputMode="numeric"
																		name="validade_identificacao"
																		value={dados.current.info.identificacao?.validade_identificacao ?? ''}
																		className="form-control rounded-0"
																		placeholder={language[lang].validade_identificacao_placeholder}
																		onChange={handle_change_identificacao}
																	/>
																</div>									
															</div>

															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].arquivo}</label>
																	<input type="text"
																		name="arquivo"
																		value={dados.current.info.identificacao?.arquivo ?? ''}
																		className="form-control rounded-0"
																		placeholder={language[lang].arquivo_placeholder}
																		onChange={handle_change_identificacao} />
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].validade_contribuinte}</label>
																	<input
																		type="text"
																		minLength="5"
																		maxLength="5"
																		inputMode="numeric"
																		name="validade_contribuinte"
																		value={dados.current.info.identificacao?.validade_contribuinte ?? ''}
																		className="form-control rounded-0"
																		placeholder={language[lang].validade_contribuinte_placeholder}
																		onChange={handle_change_identificacao}
																	/>
																</div>
															</div>

															<hr className="my-4" />
															<br />
															<h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].dados_fiscais}</h6>
															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].vat}</label>
																	<input type="text"
																		pattern={pattern_vat}
																		minLength="9"
																		inputMode='numeric'
																		name="vat"
																		value={dados.current.info.vat}
																		className="form-control rounded-0"
																		placeholder={language[lang].vat_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-6 d-none">
																	<label className="form-label fw-bold fs-6">{language[lang].iban}</label>
																	<input type="text"
																		minLength="25"
																		inputMode='numeric'
																		name="iban"
																		value={dados.current.info.identificacao?.iban ?? ''}
																		className="form-control rounded-0"
																		placeholder={language[lang].iban_placeholder}
																		onChange={handle_change_identificacao}
																	/>
																</div>
															</div>

															{/*
															<div className="row g-3 mb-4">
																<div className="col-md-6">
																	<label className="form-label fw-bold fs-6">{language[lang].nbss}</label>
																	<input type="text"
																		pattern={pattern_vat}
																		minLength="9"
																		inputMode='numeric'
																		name="nbss"
																		value={dados.current.info.identificacao?.nbss ?? ''}
																		className="form-control rounded-0"
																		placeholder={language[lang].nbss_placeholder}
																		onChange={handle_change_identificacao}
																	/>
																</div>

																<div className="col-md-6">
																	<label className="form-label fw-bold fs-6">{language[lang].ass}</label>
																	<input type="text"
																		pattern={pattern_vat}
																		minLength="9"
																		inputMode='numeric'
																		name="ass"
																		value={dados.current.info.identificacao?.ass ?? ''}
																		className="form-control rounded-0"
																		placeholder={language[lang].ass_placeholder}
																		onChange={handle_change_identificacao}
																	/>
																</div>
															</div>

															<hr className="my-4" />
															<br />
															<h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].contrato}</h6>
															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].data_admissao}</label>
																	<input type="date" name="data_admissao" value={dados.current.info.data_admissao || ''}
																		className="form-control rounded-0"
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-8">
																	<label className="form-label fw-bold fs-6">{language[lang].tipo_contrato}</label>
																	<select
																		name="tipo_contrato"
																		className="form-select rounded-0"
																		onChange={handle_change_info}
																		value={
																			dados?.current?.info?.tipo_contrato !== undefined &&
																				dados?.current?.info?.tipo_contrato !== null
																				? dados.current.info.tipo_contrato
																				: ''
																		}
																	>
																		<option value="">{language[lang].select}</option>
																		<option value="0">{language[lang].contrato_sem_termo}</option>
																		<option value="1">{language[lang].contrato_termo_certo}</option>
																		<option value="2">{language[lang].contrato_termo_incerto}</option>
																		<option value="3">{language[lang].contrato_part_time}</option>
																		<option value="4">{language[lang].contrato_estagio}</option>
																		<option value="5">{language[lang].contrato_prestacao_servicos}</option>
																		<option value="6">{language[lang].contrato_intermitente}</option>
																	</select>
																</div>
															</div>

															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].horas_semanais}</label>
																	<input type="text"
																		name="horas_semanais"
																		value={dados.current.info.horas_semanais}
																		className="form-control rounded-0"
																		placeholder={language[lang].horas_semanais_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-8">
																	<label className="form-label fw-bold fs-6">{language[lang].seguro_acidente_trabalho}</label>
																	<input type="text"
																		name="seguro_acidente_trabalho"
																		value={dados.current.info.seguro_acidente_trabalho}
																		className="form-control rounded-0"
																		placeholder={language[lang].seguro_acidente_trabalho_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>
															*/}

															<hr className="my-4" />
															<br />
															<div className="row g-3">
																<div className="col-12">
																	<label className="form-label fw-bold fs-6">{language[lang].observacoes}</label>
																	<textarea name="observation"
																		value={dados.current.info.observation}
																		className="form-control rounded-0"
																		rows="4"
																		onChange={handle_change_info} />
																</div>
															</div>
														</div>
													)}

													{showNat && (
														<div className='p-4'>
															<h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].naturalidade}</h6>
															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].local}</label>
																	<input
																		type="text"
																		name="naturalidade"
																		value={dados.current.addresses.naturalidade}
																		className="form-control rounded-0"
																		placeholder={language[lang].local_placeholder}
																		onChange={handle_change_addresses}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].village}</label>
																	<input
																		type="text"
																		name="village"
																		value={dados.current.addresses.village}
																		className="form-control rounded-0"
																		placeholder={language[lang].village_placeholder}
																		onChange={handle_change_addresses}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].city}</label>
																	<input
																		type="text"
																		name="city"
																		value={dados.current.addresses.city}
																		className="form-control rounded-0"
																		placeholder={language[lang].city_placeholder}
																		onChange={handle_change_addresses}
																	/>
																</div>
															</div>

															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].district}</label>
																	<input
																		type="text"
																		name="region"
																		value={dados.current.addresses.region}
																		className="form-control rounded-0"
																		placeholder={language[lang].district_placeholder}
																		onChange={handle_change_addresses}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].country}</label>
																	<input
																		type="text"
																		name="country"
																		value={dados.current.addresses.country}
																		className="form-control rounded-0"
																		placeholder={language[lang].country_placeholder}
																		onChange={handle_change_addresses}
																	/>
																</div>
															</div>
														</div>
													)}

													{showFunctions && (
														<div className="p-4">
															<h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].functions}</h6>
															<div className="row g-3 mb-4">
																<div className="col-md-4 d-none">
																	<label className="form-label fw-bold fs-6">{language[lang].entity}</label>
																	<select
																		name="entity_category"
																		className="form-select rounded-0"
																		onChange={change_entity_attributes}
																		value={dados?.current?.info?.attributes?.entity_category !== undefined && dados?.current?.info?.attributes?.entity_category !== null ? dados.current.info.attributes.entity_category : ''}
																		required
																	>
																		<option value="">{language[lang].select}</option>
																		{
																			entity_category.current !== undefined && entity_category.current !== null ?
																				entity_category.current.map((option, key) => (
																					<option key={key} value={option.id}>
																						{option.label}
																					</option>
																				))
																				:
																				null
																		}
																	</select>
																</div>
															</div>

															<div className="row g-3 mb-4">
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].profile}</label>
																	<select
																		name="profile"
																		className="form-select rounded-0"
																		onChange={handleUserTypeChange}
																		value={dados.current.profile.id}
																	>
																		<option value="">{language[lang].select}</option>
																		{
																			app_profiles.current !== undefined && app_profiles.current !== null ?
																				app_profiles.current.map((option, key) => (
																					<option key={key} value={option.id}>
																						{option.name}
																					</option>
																				))
																				:
																				null
																		}
																	</select>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].entity_type}</label>
																	<Select
																		isMulti
																		className="div-select"
																		options={
																			entity_profiles_filter.current !== undefined && entity_profiles_filter.current !== null
																				? entity_profiles_filter.current.map(opt => ({ value: opt.id, label: opt.name }))
																				: []
																		}
																		name="entity_profile"
																		value={
																			Array.isArray(dados.current.info.attributes?.entity_profile)
																				? dados.current.info.attributes.entity_profile.map(item => ({
																					value: item.id,
																					label: item.label !== undefined ? item.label : item.name
																				}))
																				: []
																		}
																		placeholder={language[lang].select}
																		onChange={change_entity_profile_multi}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].entity_function}</label>
																	<select
																		name="entity_function"
																		className="form-select rounded-0"
																		onChange={handleUserTypeEntityFunctionsChange}
																		value={''}
																	>
																		<option value="">{language[lang].select}</option>
																		{
																			entity_function_filter.current !== undefined && entity_function_filter.current !== null ?
																				entity_function_filter.current.map((option, key) => (
																					<option key={key} value={option.id}>
																						{option.label}
																					</option>
																				))
																				:
																				null
																		}
																	</select>

																	<div>
																		{
																			Array.isArray(dados.current.info?.attributes?.entity_function) ?
																				dados.current.info.attributes.entity_function.map((el_ep, k_ep) => {
																					return (
																						<span key={k_ep} className='badge bg-secondary mt-2 me-2 px-3 py-2 rounded-0' onClick={() => handleUserTypeEntityRemove(el_ep)}>
																							{get_entity_function(el_ep)} <i className="bi bi-x-lg ms-2 text-white"></i>
																						</span>
																					)
																				})
																				:
																				null
																		}
																	</div>
																</div>

																<div className="row g-3 mb-4">
																	<label className="form-label fw-bold fs-6">{language[lang].dep_emp}</label>
																	<div className="col-md-4">
																		<div
																			className="form-control rounded-0"
																			style={{ height: 'auto', width: '1250px', borderWidth: '1px' }}
																		>
																			{departamentos.length > 0 ? (
																				departamentos.map((departamento) => (
																					<div key={departamento.id} className="form-check">
																						<input
																							type="checkbox"
																							className="form-check-input"
																							id={`departamento-${departamento.id}`}
																							checked={checkDepartmento(departamento.id)}
																							onChange={() => escolheDepartamentos(departamento.id)}
																						/>
																						<label className="form-check-label" htmlFor={`departamento-${departamento.id}`}>
																							{departamento.name}
																						</label>
																						{departamento.software && departamento.software.length > 0 && (
																							<div className="nested-checkboxes ms-4">
																								{departamento.software
																									.filter(softwareType => softwareType.state === true)
																									.map((softwareType) => (
																										<div key={softwareType.id} className="form-check d-flex justify-content-between align-items-center">
																											<div>
																												<input
																													type="checkbox"
																													className="form-check-input"
																													id={`software-${departamento.id}-${softwareType.id}`}
																													checked={checkSoftware(departamento.id, softwareType.id)}
																													onChange={() => escolheSoftware(departamento.id, softwareType.id)}
																													disabled={!checkDepartmento(departamento.id)}
																												/>
																												<label className="form-check-label ms-2" htmlFor={`software-${departamento.id}-${softwareType.id}`}>
																													{`${language[lang].certificacao} ${softwareType.nome}`}
																												</label>
																											</div>
																											<button
																												type="button"
																												className="btn btn-sm btn-danger d-none" //d-none quando não for necessário eliminar um software
																												onClick={() => removeSoftware(departamento.id, softwareType.id)}
																											>
																												X
																											</button>
																										</div>
																									))}
																							</div>
																						)}
																					</div>
																				))
																			) : (
																				<div>{language[lang].carregar}</div>
																			)}
																		</div>
																	</div>
																</div>
															</div>
														</div>
													)}

													{showSportData && (
														<div className="p-4">
															<h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].dados_desportivos}</h6>
															<div className="row g-3 mb-4">
																<div className="col-md-4 d-none">
																	<label className="form-label fw-bold fs-6">{language[lang].numero_atleta}</label>
																	<input
																		type="text"
																		name="numero_atleta"
																		value={dados.current.info.numero_atleta ?? ''}
																		className="form-control rounded-0"
																		placeholder={language[lang].numero_atleta_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>

																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].numero_licenca}</label>
																	<input
																		type="text"
																		name="numero_licenca"
																		value={dados.current.info.numero_licenca ?? ''}
																		className="form-control rounded-0"
																		placeholder={language[lang].numero_licenca_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>

															<div className="row g-3 mb-4">
																{/* --- Clube --- */}
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].clube}</label>
																	<Select
																		isMulti
																		className="div-select"
																		options={clubes}
																		name="clube"
																		value={
																			Array.isArray(dados.current.info.clube)
																				? dados.current.info.clube.map(c => ({ value: c.id, label: c.name }))
																				: []
																		}
																		placeholder={language[lang].clube_placeholder ?? language[lang].select}
																		onChange={change_clube}
																	/>
																</div>

																{/* --- Modalidades --- */}
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].modalidades}</label>
																	<Select
																		isMulti
																		className="div-select"
																		options={modalidades_lista}
																		name="modalidades"
																		value={
																			Array.isArray(dados.current.info.modalidades)
																				? dados.current.info.modalidades.map(m => ({
																					label: m.label ?? m,
																					value: m.value ?? m,
																				}))
																				: []
																		}
																		placeholder={language[lang].modalidades_placeholder}
																		onChange={change_modalidades}
																	/>
																</div>

																{/* --- Escalão --- */}
																<div className="col-md-4">
																	<label className="form-label fw-bold fs-6">{language[lang].escalao}</label>
																	<select
																		name="escalao"
																		className="form-select rounded-0"
																		value={dados.current.info.escalao ?? ''}
																		disabled
																		onChange={(e) => {
																			escalaoAutoRef.current = '';
																			handle_change_info(e);
																		}}
																	>
																		<option value="">{language[lang].select}</option>
																		{opcoesEscalaoAtual.map((opt) => (
																			<option key={opt.id} value={opt.id}>{opt.label}</option>
																		))}
																	</select>
																</div>

																<div className="col-md-8">
																	<label className="form-label fw-bold fs-6">{language[lang].qualificacoes}</label>
																	<textarea
																		name="qualificacoes"
																		value={dados.current.info.qualificacoes ?? ''}
																		className="form-control rounded-0"
																		rows="2"
																		placeholder={language[lang].qualificacoes_placeholder}
																		onChange={handle_change_info}
																	/>
																</div>
															</div>

															{/* --- Categoria --- */}
															<div className="card mb-4">
																<hr className="my-4" />
																<h6 className="fw-bold text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].categoria}</h6>
																<div className="p-4">
																	<div className="row g-3 mb-4">
																		{[
																			{ id: 'alto_rendimento', label: language[lang].alto_rendimento },
																			{ id: 'preparacao_olimpica', label: language[lang].preparacao_olimpica },
																			{ id: 'olimpico', label: language[lang].olimpico },
																			{ id: 'paralimpico', label: language[lang].paralimpico },
																			{ id: 'selecoes', label: language[lang].selecoes },
																		].map((opt) => (
																			<div key={opt.id} className="col-md-3 mb-4 form-check">
																				<input
																					type="checkbox"
																					className="form-check-input"
																					id={`categoria-${opt.id}`}
																					value={opt.id}
																					checked={dados.current.info.categoria?.includes(opt.id) || false}
																					onChange={() => handle_categoria_change(opt.id)}
																				/>
																				<label className="form-check-label" htmlFor={`categoria-${opt.id}`}>
																					{opt.label}
																				</label>
																			</div>
																		))}
																	</div>
																</div>
															</div>

															{/* --- Deficiência --- */}
															<div className="card mb-4">
																<hr className="my-4" />
																<h6 className="fw-bold text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].deficiencia}</h6>
																<div className="p-4">
																	<div className="row g-3 mb-4">
																		<div className="col-md-4">
																			<select
																				name="deficiencia"
																				className="form-select rounded-0"
																				onChange={handle_change_info}
																				value={dados.current.info.deficiencia ?? ''}
																			>
																				<option value="">{language[lang].select}</option>
																				<option value="1">{language[lang].sim}</option>
																				<option value="0">{language[lang].nao}</option>
																			</select>
																		</div>

																		{dados.current.info.deficiencia === '1' && (
																			<div className="col-md-8">
																				<label className="form-label fw-bold fs-6">{language[lang].descricao}</label>
																				<textarea
																					name="deficiencia_descricao"
																					value={dados.current.info.deficiencia_descricao ?? ''}
																					className="form-control rounded-0"
																					rows="3"
																					onChange={handle_change_info}
																				/>
																			</div>
																		)}
																	</div>
																</div>
															</div>

															{/* --- Tipo de prática desportiva --- */}
															<div className="card mb-4">
																<hr className="my-4" />
																<h6 className="fw-bold text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].tipo_pratica_desportiva}</h6>
																<div className="p-4">
																	<div className="row g-3 mb-4">
																		{[
																			{ id: '0', label: language[lang].lazer },
																			{ id: '1', label: language[lang].competicao },
																		].map((opt) => (
																			<div key={opt.id} className="col-md-3 form-check">
																				<input
																					type="radio"
																					className="form-check-input"
																					id={`tipo_pratica-${opt.id}`}
																					name="tipo_pratica"
																					value={opt.id}
																					checked={dados.current.info.tipo_pratica === opt.id}
																					onChange={handle_change_info}
																				/>
																				<label className="form-check-label" htmlFor={`tipo_pratica-${opt.id}`}>
																					{opt.label}
																				</label>
																			</div>
																		))}
																	</div>
																</div>
															</div>

															{/* --- Programas (Ice4all, Biathlon4all, ...) --- */}
															<div className="card mb-4">
																<hr className="my-4" />
																<h6 className="fw-bold text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].programas}</h6>
																<div className="p-4">
																	<div className="row g-3 mb-4">
																		{[
																			{ id: 'ice4all', label: 'Ice4all' },
																			{ id: 'biathlon4all', label: 'Biathlon4all' },
																			{ id: 'hoquei_escolas', label: 'Hóquei nas Escolas' },
																			{ id: 'curling_escolas', label: 'Curling nas Escolas' }
																		].map((programa) => (
																			<div key={programa.id} className="col-md-3 form-check">
																				<input
																					type="checkbox"
																					className="form-check-input"
																					id={`programa-${programa.id}`}
																					checked={dados.current.info.programas?.includes(programa.id) || false}
																					onChange={() => handle_programa_change(programa.id)}
																				/>
																				<label className="form-check-label" htmlFor={`programa-${programa.id}`}>
																					{programa.label}
																				</label>
																			</div>
																		))}
																	</div>
																</div>
															</div>

															{/* --- Projetos --- */}
															<div className="card mb-4 d-none">
																<hr className="my-4" />
																<h6 className="fw-bold text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].projetos}</h6>
																<div className="p-4">
																	<div className="row g-3 mb-4">
																		{[
																			{ id: 'projeto_pais', label: 'Projeto P.A.I.S.' }
																		].map((projeto) => (
																			<div key={projeto.id} className="col-md-3 form-check">
																				<input
																					type="checkbox"
																					className="form-check-input"
																					id={`projeto-${projeto.id}`}
																					checked={dados.current.info.projetos?.includes(projeto.id) || false}
																					onChange={() => handle_projeto_change(projeto.id)}
																				/>
																				<label className="form-check-label" htmlFor={`projeto-${projeto.id}`}>
																					{projeto.label}
																				</label>
																			</div>
																		))}
																	</div>
																</div>
															</div>

															{/* --- Projeto P.A.I.S. --- */}
															<div className="card mb-4">
																<hr className="my-4" />
																<h6 className="fw-bold text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].projeto_pais}</h6>
																<div className="p-4">
																	<div className="form-check">
																		<input
																			type="checkbox"
																			className="form-check-input"
																			id="projeto_pais"
																			checked={dados.current.info.projeto_pais === true}
																			onChange={(e) => set_dados(dados.current.info.projeto_pais = e.target.checked)}
																		/>
																		<label className="form-check-label" htmlFor="projeto_pais">
																			{language[lang].projeto_pais_participa}
																		</label>
																	</div>
																</div>
															</div>

															{/* --- Documentação Associada --- */}
															<div className="card mb-4">
																<hr className="my-4" />
																<h6 className="fw-bold text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].documentacao_associada}</h6>
																<div className="p-4">
																	<div className="row g-3 mb-4 align-items-end">
																		<div className="col-md-4">
																			<label className="col-form-label fw-bold fs-6 d-block">{language[lang].exames_medicos}</label>
																			<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor="input-files-exame-medico">
																				{language[lang].doc_choose}
																			</label>
																			<input
																				id="input-files-exame-medico"
																				type="file"
																				accept="application/pdf"
																				data-order={'2'}
																				data-langid={'1'}
																				data-lang={lang}
																				data-type={'doc'}
																				className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																				onChange={onChangeHandlerFilesPDF}
																				multiple
																			/>
																		</div>
																		<div className="col-md-4">
																			<label className="form-label fw-bold fs-6">{language[lang].data_exame_medico}</label>
																			<input
																				type="date"
																				name="data_exame_medico"
																				value={dados.current.info.data_exame_medico ?? ''}
																				className="form-control rounded-0"
																				onChange={handle_change_info}
																			/>
																		</div>
																	</div>

																	{/* Contratos (desportivos) */}
																	<div className="row g-3 mb-4">
																		<div className="col-md-8">
																			<label className="col-form-label fw-bold fs-6 d-block">{language[lang].contratos}</label>
																			<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor="input-files-contrato-desportivo">
																				{language[lang].doc_choose}
																			</label>
																			<input
																				id="input-files-contrato-desportivo"
																				type="file"
																				accept="application/pdf"
																				data-order={'3'}
																				data-langid={'1'}
																				data-lang={lang}
																				data-type={'doc'}
																				className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																				onChange={onChangeHandlerFilesPDF}
																				multiple
																			/>
																		</div>
																	</div>

																	{/* Seguro */}
																	<div className="row g-3 mb-4">
																		<div className="col-md-8">
																			<label className="col-form-label fw-bold fs-6 d-block">{language[lang].seguro}</label>
																			<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor="input-files-seguro">
																				{language[lang].doc_choose}
																			</label>
																			<input
																				id="input-files-seguro"
																				type="file"
																				accept="application/pdf"
																				data-order={'4'}
																				data-langid={'1'}
																				data-lang={lang}
																				data-type={'doc'}
																				className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																				onChange={onChangeHandlerFilesPDF}
																				multiple
																			/>
																		</div>
																	</div>

																	{/* Certificados */}
																	<div className="row g-3 mb-4">
																		<div className="col-md-8">
																			<label className="col-form-label fw-bold fs-6 d-block">{language[lang].certificados}</label>
																			<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor="input-files-certificados">
																				{language[lang].doc_choose}
																			</label>
																			<input
																				id="input-files-certificados"
																				type="file"
																				accept="application/pdf"
																				data-order={'6'}
																				data-langid={'1'}
																				data-lang={lang}
																				data-type={'doc'}
																				className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																				onChange={onChangeHandlerFilesPDF}
																				multiple
																			/>
																		</div>
																	</div>

																	{/* Licenças */}
																	<div className="row g-3 mb-4">
																		<div className="col-md-8">
																			<label className="col-form-label fw-bold fs-6 d-block">{language[lang].licencas}</label>
																			<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor="input-files-licencas">
																				{language[lang].doc_choose}
																			</label>
																			<input
																				id="input-files-licencas"
																				type="file"
																				accept="application/pdf"
																				data-order={'7'}
																				data-langid={'1'}
																				data-lang={lang}
																				data-type={'doc'}
																				className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																				onChange={onChangeHandlerFilesPDF}
																				multiple
																			/>
																		</div>
																	</div>

																	{/* Registo Criminal */}
																	<div className="row g-3 mb-4">
																		<div className="col-md-8">
																			<label className="col-form-label fw-bold fs-6 d-block">{language[lang].registo_criminal}</label>
																			<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor="input-files-registo-criminal">
																				{language[lang].doc_choose}
																			</label>
																			<input
																				id="input-files-registo-criminal"
																				type="file"
																				accept="application/pdf"
																				data-order={'8'}
																				data-langid={'1'}
																				data-lang={lang}
																				data-type={'doc'}
																				className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																				onChange={onChangeHandlerFilesPDF}
																				multiple
																			/>
																		</div>
																	</div>

																	{/* Outros documentos pessoais */}
																	<div className="row g-3 mb-4">
																		<div className="col-md-8">
																			<label className="col-form-label fw-bold fs-6 d-block">{language[lang].outros_documentos}</label>
																			<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor="input-files-outros-doc">
																				{language[lang].doc_choose}
																			</label>
																			<input
																				id="input-files-outros-doc"
																				type="file"
																				accept="application/pdf"
																				data-order={'5'}
																				data-langid={'1'}
																				data-lang={lang}
																				data-type={'doc'}
																				className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																				onChange={onChangeHandlerFilesPDF}
																				multiple
																			/>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													)}

													{showGuardians && is_minor && (
														<div className="p-4">
															<h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].pais_encarregados}</h6>
															<div className="row g-3 mb-4">
																<div className="card-body">
																	{[
																		{ key: 'pai', label: language[lang].nome_contacto_pai },
																		{ key: 'mae', label: language[lang].nome_contacto_mae },
																		{ key: 'encarregado_educacao', label: language[lang].nome_contacto_encarregado },
																		{ key: 'emergencia', label: language[lang].contacto_emergencia },
																	].map((pessoa) => (
																		<div key={pessoa.key} className="row g-3 mb-4">
																			<div className="col-md-4">
																				<label className="form-label fw-bold fs-6">{pessoa.label} — {language[lang].name}</label>
																				<input
																					type="text"
																					className="form-control rounded-0"
																					value={dados.current.info.encarregados?.[pessoa.key]?.nome ?? ''}
																					onChange={(e) => handle_change_encarregados(pessoa.key, 'nome', e.target.value)}
																				/>
																			</div>
																			<div className="col-md-4">
																				<label className="form-label fw-bold fs-6">{pessoa.label} — {language[lang].tlm}</label>
																				<PhoneInput
																					defaultCountry="PT"
																					className="form-control rounded-0"
																					value={dados.current.info.encarregados?.[pessoa.key]?.contacto ?? null}
																					onChange={(valor) => handle_change_encarregados(pessoa.key, 'contacto', valor)}
																				/>
																			</div>
																		</div>
																	))}
																</div>
															</div>
														</div>
													)}

													{showSelecoes && is_selecionado && (
														<div className="p-4">
															<div className="row g-3 mb-4">
																<div className="card-body">
																	<div className="col-md-4">
																		<label className="form-label fw-bold fs-6">{language[lang].ocupacao}</label>
																		<select
																			name="type"
																			className="form-select rounded-0"
																			onChange={handle_change_info_ocupacao}
																			value={
																				dados?.current?.info?.ocupacao?.type !== undefined &&
																					dados?.current?.info?.ocupacao?.type !== null
																					? dados.current.info.ocupacao?.type
																					: ''
																			}
																		>
																			<option value="">{language[lang].select}</option>
																			<option value="0">{language[lang].empregado}</option>
																			<option value="1">{language[lang].desempregado}</option>
																			<option value="2">{language[lang].estudante}</option>
																			<option value="3">{language[lang].outro}</option>
																		</select>
																	</div>
																	<div className={'col-12' + (dados?.current?.info?.ocupacao?.type !== undefined && (dados.current.info.ocupacao.type === '0' || dados.current.info.ocupacao.type === '2') ? '' : ' d-none')}>
																		<hr className="my-4" />

																		<div className={"row g-3 mb-4" + (dados?.current?.info?.ocupacao?.type !== undefined && (dados.current.info.ocupacao.type === '0') ? '' : ' d-none')}>
																			<div className="col-md-4">
																				<label className="form-label fw-bold fs-6">{language[lang].entidade_patronal}</label>
																				<input type="text" name="entidade" value={dados?.current?.info?.ocupacao?.entidade !== undefined ? dados.current.info.ocupacao.entidade : ''} className="form-control rounded-0 py-2" placeholder={language[lang].entidade_patronal_placeholder} onChange={handle_change_info_ocupacao} />
																			</div>
																			<div className="col-md-4">
																				<label className="form-label fw-bold fs-6">{language[lang].tipo_entidade}</label>
																				<select
																					name="tipo_entidade"
																					className="form-select rounded-0"
																					onChange={handle_change_info_ocupacao}
																					value={
																						dados?.current?.info?.tipo_entidade !== undefined &&
																							dados?.current?.info?.tipo_entidade !== null
																							? dados.current.info.tipo_entidade
																							: ''
																					}
																				>
																					<option value="">{language[lang].select}</option>
																					<option value="0">{language[lang].entidade_publica}</option>
																					<option value="1">{language[lang].entidade_privada}</option>
																					<option value="2">{language[lang].entidade_militar}</option>
																				</select>
																			</div>
																			<div className="col-md-4">
																				<label className="form-label fw-bold fs-6">{language[lang].profissao}</label>
																				<input type="text" name="profissao" value={dados?.current?.info?.ocupacao?.profissao !== undefined ? dados.current.info.ocupacao.profissao : ''} className="form-control rounded-0 py-2" placeholder={language[lang].profissao_placeholder} onChange={handle_change_info_ocupacao} />
																			</div>
																		</div>

																		<div className={"row g-3 mb-4" + (dados?.current?.info?.ocupacao?.type !== undefined && (dados.current.info.ocupacao.type === '2') ? '' : ' d-none')}>
																			<div className="col-md-4">
																				<label className="form-label fw-bold fs-6">{language[lang].nome_escola}</label>
																				<input type="text" name="entidade" value={dados?.current?.info?.ocupacao?.entidade !== undefined ? dados.current.info.ocupacao.entidade : ''} className="form-control rounded-0 py-2" placeholder={language[lang].nome_escola_placeholder} onChange={handle_change_info_ocupacao} />
																			</div>
																			<div className="col-md-4">
																				<label className="form-label fw-bold fs-6">{language[lang].ano_escolar}</label>
																				<input type="text" name="ano_escolar" value={dados?.current?.info?.ocupacao?.ano_escolar !== undefined ? dados.current.info.ocupacao.ano_escolar : ''} className="form-control rounded-0 py-2" placeholder={language[lang].ano_escolar_placeholder} onChange={handle_change_info_ocupacao} />
																			</div>
																			<div className="col-md-4">
																				<label className="form-label fw-bold fs-6">{language[lang].area_escolar}</label>
																				<input type="text" name="area_escolar" value={dados?.current?.info?.ocupacao?.area_escolar !== undefined ? dados.current.info.ocupacao.area_escolar : ''} className="form-control rounded-0 py-2" placeholder={language[lang].area_escolar_placeholder} onChange={handle_change_info_ocupacao} />
																			</div>
																			<div className="col-md-4">
																				<label className="form-label fw-bold fs-6">{language[lang].turma_escolar}</label>
																				<input type="text" name="turma_escolar" value={dados?.current?.info?.ocupacao?.turma_escolar !== undefined ? dados.current.info.ocupacao.turma_escolar : ''} className="form-control rounded-0 py-2" placeholder={language[lang].turma_escolar_placeholder} onChange={handle_change_info_ocupacao} />
																			</div>
																			<div className="col-md-4">
																				<label className="form-label fw-bold fs-6">{language[lang].numero_escolar}</label>
																				<input type="text" name="numero_escolar" value={dados?.current?.info?.ocupacao?.numero_escolar !== undefined ? dados.current.info.ocupacao.numero_escolar : ''} className="form-control rounded-0 py-2" placeholder={language[lang].numero_escolar_placeholder} onChange={handle_change_info_ocupacao} />
																			</div>
																		</div>
																		
																		<div className="row g-3 mb-4">
																			<div className="col-md-4">
																				<label className="form-label fw-bold fs-6">{language[lang].tlf}</label>
																				<input type="text" name="telefone" value={dados?.current?.info?.ocupacao?.telefone !== undefined ? dados.current.info.ocupacao.telefone : ''} className="form-control rounded-0 py-2" placeholder={language[lang].tlf_placeholder} onChange={handle_change_info_ocupacao} />
																			</div>
																			<div className="col-md-4">
																				<label className="form-label fw-bold fs-6">{language[lang].email}</label>
																				<input type="email" name="email" value={dados?.current?.info?.ocupacao?.email !== undefined ? dados.current.info.ocupacao.email : ''} className="form-control rounded-0 py-2" placeholder={language[lang].email_placeholder} onChange={handle_change_info_ocupacao} />
																			</div>
																		</div>


																		<div className="row g-3 mb-4">
																			<div className="col-12">
																				<label className="form-label fw-bold fs-6">{language[lang].morada}</label>
																				<textarea name="address_detail" value={dados?.current?.info?.ocupacao?.address_detail !== undefined ? dados.current.info.ocupacao.address_detail : ''} className="form-control rounded-0" rows="3" onChange={handle_change_info_ocupacao} />
																			</div>
																		</div>

																		<div className="row g-3 mb-4">
																			<div className="col-md-4">
																				<label className="form-label fw-bold fs-6">{language[lang].local}</label>
																				<input type="text" name="localidade" value={dados?.current?.info?.ocupacao?.localidade !== undefined ? dados.current.info.ocupacao.localidade : ''} className="form-control rounded-0 py-2" placeholder={language[lang].local_placeholder} onChange={handle_change_info_ocupacao} />
																			</div>

																			<div className={"col-md-4"}>
																				<label className="form-label fw-bold fs-6">{language[lang].postal_code}</label>
																				<input type="text" name="postal_code" value={dados?.current?.info?.ocupacao?.postal_code !== undefined ? dados.current.info.ocupacao.postal_code : ''} className="form-control rounded-0 py-2" placeholder={language[lang].postal_code_placeholder} onChange={handle_change_info_ocupacao} />
																			</div>

																			<div className={"col-md-4"}>
																				<label className="form-label fw-bold fs-6">{language[lang].village}</label>
																				<Select
																					className="div-select"
																					options={villages}
																					name="freguesia"
																					value={dados?.current?.info?.ocupacao?.village === undefined || dados.current.info.ocupacao.village === '' ? null : { label: dados.current.info.ocupacao.village, value: dados.current.info.ocupacao.village }}
																					placeholder={language[lang].village_placeholder}
																					onChange={change_ocupacao_village}
																				/>
																			</div>
																		</div>

																		<div className="row g-3 mb-4">
																			<div className={"col-md-4"}>
																				<label className="form-label fw-bold fs-6">{language[lang].city}</label>
																				<Select
																					className="div-select"
																					options={cities}
																					name="concelho"
																					value={dados?.current?.info?.ocupacao?.city === undefined || dados.current.info.ocupacao.city === '' ? null : { label: dados.current.info.ocupacao.city, value: dados.current.info.ocupacao.city }}
																					placeholder={language[lang].city_placeholder}
																					onChange={change_ocupacao_city}
																				/>
																			</div>

																			<div className={"col-md-4"}>
																				<label className="form-label fw-bold fs-6">{language[lang].district}</label>
																				<Select
																					className="div-select"
																					options={districts}
																					name="distrito"
																					value={dados?.current?.info?.ocupacao?.region === undefined || dados.current.info.ocupacao.region === '' ? null : { label: dados.current.info.ocupacao.region, value: dados.current.info.ocupacao.region }}
																					placeholder={language[lang].district_placeholder}
																					onChange={change_ocupacao_district}
																				/>
																			</div>

																			<div className={"col-md-4"}>
																				<label className="form-label fw-bold fs-6">{language[lang].country}</label>
																				<Select
																					className="div-select"
																					options={countries}
																					name="pais"
																					value={dados?.current?.info?.ocupacao?.country === undefined || dados.current.info.ocupacao.country === '' ? null : { label: dados.current.info.ocupacao.country, value: dados.current.info.ocupacao.country }}
																					placeholder={language[lang].country_placeholder}
																					onChange={change_ocupacao_country}
																				/>
																			</div>
																		</div>
																	</div>

																	<div className={"col-12" + (dados?.current?.info?.ocupacao?.type !== undefined && (dados.current.info.ocupacao.type === '3') ? '' : ' d-none')}>
																		<div className=" mt-4">
																			<label className="form-label fw-bold fs-6">{language[lang].ocupacao_descricao}</label>
																			<textarea name="ocupacao_descricao" value={dados?.current?.info?.ocupacao?.ocupacao_descricao !== undefined ? dados.current.info.ocupacao.ocupacao_descricao : ''} className="form-control rounded-0" rows="3" onChange={handle_change_info_ocupacao} />
																		</div>
																	</div>
																</div>
															</div>
														</div>
													)}

													{showSettings && (
														<div className="p-4">
															<h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: '13px' }}>{language[lang].settings}</h6>
															<div className="row g-3 mb-4">
																<div className="col-md-6">
																	<div className="mb-3">
																		<label className="form-label fw-bold fs-6">
																			{language[lang].username}
																		</label>
																		<input
																			type="text"
																			name="username"
																			value={dados.current.info.username}
																			pattern="[a-zA-Z\u00C0-\u00FF.]+"
																			className="form-control"
																			placeholder={language[lang].username_placeholder}
																			onChange={handle_change_info}
																			onBlur={handle_change_login}
																			autoComplete="off"
																		/>
																	</div>

																	<div className="mb-3">
																		<label className="form-label fw-bold fs-6">
																			{language[lang].password}
																		</label>
																		<input
																			type="password"
																			name="password"
																			value={new_password}
																			min="9"
																			title="A password deve de conter pelo menos 9 digitos alfa-númericos"
																			className="form-control"
																			placeholder={is_edit ? "*************" : language[lang].password_placeholder}
																			onChange={handle_change_info_new_password}
																			autoComplete="off"
																		/>
																	</div>

																	<div className="mb-4">
																		<label className="form-label fw-bold fs-6">
																			{language[lang].password_confirmation}
																		</label>
																		<input
																			type="password"
																			name="password_conf"
																			defaultValue={confirm_password}
																			min="9"
																			className="form-control"
																			placeholder={is_edit ? "*************" : language[lang].password_placeholder}
																			onBlur={handle_change_password}
																			autoComplete="off"
																		/>
																	</div>

																	<div className="div-doc">
																		<label className="col-form-label fw-bold fs-6">{language[lang].carregar_cv}</label>

																		<div className="dropzone-panel mb-lg-0 mb-2">
																			<div className="div-form-input col-12 custom-file">
																				<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-pdf-" + '0' + '-' + '1'}>{language[lang].doc_choose}</label>
																				<input
																					id={"input-files-pdf-" + '0' + '-' + '1'}
																					type="file"
																					accept="application/pdf"
																					data-order={'0'}
																					data-langid={'1'}
																					data-lang={lang}
																					data-type={'doc'}
																					className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																					onChange={onChangeHandlerFilesPDF}
																					multiple
																				/>
																			</div>
																		</div>

																		<div className="row">
																			{
																				treeDataCV !== undefined && treeDataCV[0] !== undefined && treeDataCV[0][1] !== undefined ?
																					<SortableTree
																						isVirtualized={false}
																						treeData={treeDataCV[0][1]}
																						maxDepth={1}
																						canDrag={false}
																						onChange={treeDataCV => handle_change_tree(treeDataCV, '0', '1')}
																						getNodeKey={({ node }) => node.id}
																						generateNodeProps={extendedNode => ({
																							title: (
																								<input type="text" className="form-control form-control-sm rounded-0" defaultValue={extendedNode.node.title} data-order={0} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree} />
																							),
																							buttons: [
																								<button type="button" onClick={() => open_link(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																								<button type="button" onClick={() => copy_clipboard(extendedNode.node.link)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																								<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash')}></i></button>,
																								<button type="button" onClick={() => remove_element_tree_cv('0', '1', extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																							],
																						})}
																					/>
																					:
																					null
																			}
																		</div>
																	</div>
																</div>

																<div className="col-md-6 mb-3 p-4 bg-white shadow-sm rounded">
																	<label className="form-label fw-bold fs-6 d-block">{language[lang].photo}</label>
																	<ul className="list-unstyled d-flex flex-wrap gap-3 mt-3 justify-content-center">
																		{
																			photo_base64 !== '' ?
																				<img
																					src={photo_base64}
																					className="img-fluid rounded"
																					alt="Uploaded"
																					style={{ width: "120px", height: "120px", objectFit: "cover" }}
																				/>
																				:
																				dados?.current?.info?.foto?.length > 0 ? (
																					dados.current.info.foto.map((file, index) => {
																						const imageURL = file.link || URL.createObjectURL(file);
																						return (
																							<li key={index} className="d-flex flex-column align-items-center">
																								<img
																									src={imageURL}
																									className="img-fluid rounded"
																									alt="Uploaded"
																									style={{ width: "120px", height: "120px", objectFit: "cover" }}
																								/>
																								<small className="mt-2 text-muted d-none">{file.name || 'Imagem'}</small>
																							</li>
																						);
																					})
																				) : (
																					<li className="text-muted">{language[lang].noPhoto}</li>
																				)}
																	</ul>

																	<div className="d-flex justify-content-center mt-4 gap-2">
																		<input
																			type="file"
																			accept="image/*"
																			onChange={onChangeHandlerFilesImage}
																			data-order={1}
																			data-langid={lang_id}
																			data-lang={lang}
																			data-type={'image'}
																			className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																			id="photo-upload"
																		/>

																		<label htmlFor="photo-upload" className="btn btn-outline-primary btn-sm">
																			{language[lang].photo}
																		</label>

																		{dados?.current?.info?.foto?.length > 0 && (
																			<button
																				type="button"
																				onClick={handleFileRemove}
																				style={{
																					marginLeft: "5px",
																					backgroundColor: color.corVermelha.rgb,
																					color: "#FFF",
																					border: "none",
																					borderRadius: "5px",
																					cursor: "pointer",
																					padding: "3px 10px",
																				}}
																			>
																				X
																			</button>
																		)}
																	</div>
																</div>
															</div>
														</div>
													)}
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div >
				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className={(getTokenInfo().profile === 'Cliente') ? 'd-none' : "nav-item"}>
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}